window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === 'undefined'
        ? ''
        : options.tableWrapperClass;

    options.$tables.wrap(
      '<div class="' + tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === 'undefined'
        ? ''
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(
      number,
      precision,
      thousands,
      decimal
    ) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.singleOptionButton = options.singleOptionButton;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
    $(this.singleOptionButton).on('click', e => {
      const target = e.target;

      const activeButton = document.getElementsByClassName(
        'button-selectors__button active'
      );

      const optionValue = target.value;
      const optionSelector = target.getAttribute(
        'data-option-selector'
      );
      const collectionIndex = target.getAttribute(
        'data-quick-buy-index'
      );
      const selector = document.getElementById(optionSelector);
      selector.value = optionValue;

      if (collectionIndex) {
        const quickBuyID = 'quick-buy-' + collectionIndex;
        const quickbuy = document.getElementById(quickBuyID);
        const optionCount = quickbuy.getElementsByClassName(
          'selector-wrapper'
        ).length;
        const checkCount = quickbuy.querySelectorAll(
          'input[type="radio"]:checked'
        ).length;
        if (optionCount == checkCount) {
          const addToCartID = 'quick-buy-submit-' + collectionIndex;
          const submitButton = document.getElementById(addToCartID);
          submitButton.classList.remove('soft-hide-space');
        }
      }

      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });
      if (variant) this._updateMasterSelect(variant);
    });
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage =
        this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price ===
          this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value =
        variant.id;
    }
  });

  return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    singleOptionButton: '[data-single-option-button]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState:
        this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      singleOptionButton: selectors.singleOptionButton,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(
      selectors.productFeaturedImage,
      this.$container
    );

    this.$container.on(
      'variantChange' + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      'variantPriceChange' + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(
        this.$featuredImage.attr('src')
      );
      slate.Image.preload(
        this.productSingleObject.images,
        this.settings.imageSize
      );

      this.$container.on(
        'variantImageChange' + this.namespace,
        this.updateProductImage.bind(this)
      );
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass(
          'hide'
        );
      } else {
        $(selectors.addToCart, this.$container).prop(
          'disabled',
          true
        );
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        // make sure all options are selected before button is enabled
        if (
          Object.values(
            document.querySelectorAll('.button-selectors__wrapper')
          ).every(optionSet =>
            Object.values(
              optionSet.querySelectorAll('input[type=radio]')
            ).some(radio => radio.checked)
          )
        ) {
          $(selectors.addToCart, this.$container).prop(
            'disabled',
            false
          );
        }

        if (
          $(selectors.addToCartText, this.$container)[0].hasAttribute(
            'data-pre-order'
          )
        ) {
          $(selectors.addToCartText, this.$container).html(
            theme.strings.preOrder
          );
        } else {
          // make sure all options are selected before text is updated
          if (
            Object.values(
              document.querySelectorAll('.button-selectors__wrapper')
            ).every(optionSet =>
              Object.values(
                optionSet.querySelectorAll('input[type=radio]')
              ).some(radio => radio.checked)
            )
          ) {
            $(selectors.addToCartText, this.$container).html(
              theme.strings.addToCart
            );
          }
        }
        $('#BIS_trigger').hide(); // hide the button
      } else {
        $(selectors.addToCart, this.$container).prop(
          'disabled',
          true
        );
        $(selectors.addToCartText, this.$container).html(
          theme.strings.soldOut
        );
        $('#BIS_trigger').show().attr('data-variant-id', variant.id); // show the button and set the default variant
      }

      if (
        window.theme.klarnaMessage.enabled === 'true' &&
        $('#klarna-promo').length
      ) {
        $('#klarna-promo').attr(
          'data-purchase-amount',
          variant.price
        );
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({
          eventName: 'refresh-placements'
        });
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container)
        .html(
          slate.Currency.formatMoney(variant.price, theme.moneyFormat)
        )
        .attr('data-variant-id', variant.id);

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm');
  const editAddressForm = document.querySelectorAll('.edit-address');
  const newAddressForm = document.querySelector('.new-address');
  const addressButtonState = document.querySelector(
    '.addresses__button-state'
  );
  const editAdressBtn = document.querySelectorAll('.addresses__edit');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      'AddressCountryNew',
      'AddressProvinceNew',
      {
        hideElement: 'AddressProvinceContainerNew'
      }
    );
  }

  // Add adress btn listener
  addressButtonState.addEventListener('click', e => {
    e.preventDefault();

    let defaultText = e.currentTarget.getAttribute('data-text');

    if (addressButtonState.classList.contains('cancel') == true) {
      editAddressForm.forEach(el => {
        el.classList.add('hide');
      });

      newAddressForm.classList.add('hide');
      addressButtonState.textContent = defaultText;
      addressButtonState.classList.add('add');
      addressButtonState.classList.remove('cancel');
      return;
    }

    if (addressButtonState.classList.contains('add')) {
      newAddressForm.classList.remove('hide');
      addressButtonState.classList.remove('add');
      addressButtonState.classList.add('cancel');
      addressButtonState.textContent = 'Cancel';
      return;
    }
  });

  // Edit adress btn listener
  editAdressBtn.forEach(el => {
    el.addEventListener('click', e => {
      let formId = e.currentTarget.getAttribute('data-form-id');
      let handleForm = document.querySelector(
        `#EditAddress_${formId}`
      );

      editAddressForm.forEach(el => {
        el.classList.add('hide');
      });

      if (handleForm) {
        addressButtonState.textContent = 'Cancel';
        addressButtonState.classList.add('cancel');
        newAddressForm.classList.add('hide');
        handleForm.classList.remove('hide');
        handleForm.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(
      countrySelector,
      provinceSelector,
      {
        hideElement: containerSelector
      }
    );
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function (e) {
    e.preventDefault();

    $newAddressForm.toggleClass('hide');

    if (!$newAddressForm.hasClass('hide')) {
      $('html, body').animate(
        {
          scrollTop: $('body').offset().top
        },
        'slow'
      );
    }
  });

  $('.address-edit-toggle').on('click', function () {
    $('.edit-address').addClass('hide');
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');

    $('html, body').animate(
      {
        scrollTop: $('#EditAddress_' + formId).offset().top
      },
      'slow'
    );
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    console.log(formId);
    var confirmMessage = $el.data('confirm-message');
    if (
      confirm(
        confirmMessage ||
          'Are you sure you wish to delete this address?'
      )
    ) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' }
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on(
    'click',
    onShowHidePasswordForm
  );

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/*================ Global ================*/
/**
 * Utility functions to toggle a "no-scroll" state where body can't be scrolled.
 * Useful to when opening modals/minicarts, or to "contain" scrolling inside
 * them on iOS.
 *
 * @exports window.rfd.noscroll.contain()
 * @exports window.rfd.noscroll.apply()
 * @exports window.rfd.noscroll.remove()
 */

(function noScrollFunction() {
  'use strict';

  var selectors = {
    main: 'body',
    contain: '[data-scroll-contain]'
  };

  var NO_SCROLL_CLASS = 'no-scroll';
  var scrollPosition = 0;

  var stickySelector = '.sticky-container';
  var stickyFixedClass = 'is-fixed';
  var stickyMq = 'only screen and (min-width: 990px)';

  /**
   * Switches elements with position: stick to fixed position while
   * body.no-scroll is active. Fixes issue in Firefox where sticky position
   * is document relative (not viewport relative) with body "position: fixed"
   */
  function toggleStickyPositions(toggle) {
    var $stickies = $(stickySelector);

    // ignore when has inline position (Stickyfill active, no fix needed)
    if (!$stickies.length || $stickies.get(0).style.position !== '') {
      return;
    }

    if (!toggle) {
      $stickies.each(function noScrollResetStickies() {
        $(this).removeClass(stickyFixedClass).css({
          position: '',
          left: '',
          top: ''
        });
      });

      return;
    }

    if (!window.matchMedia(stickyMq).matches) {
      return;
    }

    $stickies.each(function noScrollAddStickies() {
      var offset = $(this).offset();
      var offsetTopViewport = offset.top - $(document).scrollTop();
      var offsetLeftViewport = offset.left - $(document).scrollLeft();
      var width = $(this).outerWidth(true);

      $(this).addClass(stickyFixedClass).css({
        left: offsetLeftViewport,
        top: offsetTopViewport,
        width: width
      });
    });
  }

  /**
   * Disables scrolling on the body element
   */
  function apply() {
    console.log('noscroll apply');

    toggleStickyPositions(true);

    scrollPosition = window.pageYOffset;
    $('body').addClass(NO_SCROLL_CLASS);
    $(selectors.main).css({
      top: -scrollPosition + 'px',
      position: 'relative'
    });
  }

  /**
   * Restores scrolling on the body element
   */
  function remove() {
    console.log('noscroll remove');

    toggleStickyPositions(false);

    $('body').removeClass(NO_SCROLL_CLASS);
    $(selectors.main).css({
      top: '',
      position: ''
    });
    window.scrollTo(0, scrollPosition);
  }

  /**
   * Contains scrolling within the given element. This is useful on iOS
   * to prevent the body scrolling behind an element with its own
   * overflow scrolling.
   *
   * @param {node} overlayEl - DOM node to contain scrolling within
   */
  function contain(overlayEl) {
    var yPosition = null; // remember Y position on touch start

    overlayEl.addEventListener(
      'touchstart',
      function noScrollDetectTouch(event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          yPosition = event.targetTouches[0].clientY;
        }
      },
      false
    );

    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
     */
    function isOverlayTotallyScrolled() {
      return (
        overlayEl.scrollHeight - overlayEl.scrollTop <=
        overlayEl.clientHeight
      );
    }

    function disableRubberBand(event) {
      var clientY = event.targetTouches[0].clientY - yPosition;

      if (overlayEl.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }

      if (isOverlayTotallyScrolled() && clientY < 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }
    }

    overlayEl.addEventListener(
      'touchmove',
      function noScrollDisableRubberBand(event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          disableRubberBand(event);
        }
      },
      false
    );
  }

  function containScrollers() {
    $(selectors.contain).each(function containScrollersLoop() {
      contain(this);
    });
  }

  function init() {
    containScrollers();
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.noscroll = {};
  window.rfd.noscroll.apply = apply;
  window.rfd.noscroll.remove = remove;
  window.rfd.noscroll.contain = contain;
})();

/**
 * Open and close "off-canvas" / "slide out" / "hamburger" menus.
 *
 * Menus can be opened from links using href="#menu-id", or dynamically from JS.
 *
 * @exports window.rfd.toggleMenu()
 * @exports window.rfd.openMenu()
 * @exports window.rfd.closeMenu()
 * @exports window.rfd.closeAllMenus()
 *
 * @requires window.rfd.noscroll
 */

(function offCanvasFunction() {
  'use strict';

  var $menus = $('.off-canvas');

  var DIMMER_TRANS_LENGTH = 700;

  if (!$menus.length) {
    return;
  }

  function dimmerHide() {
    $('.off-canvas__dimmer').addClass('hide');
  }

  function dimmerShow() {
    $('.off-canvas__dimmer').removeClass('hide');
  }

  function afterClose() {
    dimmerHide();
  }

  function closeMenu(menu) {
    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.remove();
    }

    $(menu).attr('aria-hidden', true);
    $('body').removeClass(
      'is-offcanvas-open is-offcanvas-push-left is-offcanvas-push-right is-offcanvas-medium is-small-offcanvas-full'
    );

    setTimeout(afterClose, DIMMER_TRANS_LENGTH);
  }

  function closeAllMenus() {
    $menus
      .filter('[aria-hidden="false"]')
      .each(function closeMenusLoop(i, menu) {
        closeMenu(menu);
      });

    $('#off-canvas-close-cross').hide();
  }

  function afterOpen(menu) {
    if ($(menu).is('#main-nav')) {
      $('#off-canvas-close-cross').fadeIn(300);
    }
  }

  function openMenu(menu) {
    var isOpenClass;
    var $focusEl;

    if ($(menu).attr('aria-hidden') === 'false') {
      // early return if menu is already open
      return;
    }

    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.apply();
    }

    dimmerShow();

    isOpenClass = 'is-offcanvas-open';
    if ($(menu).is('.off-canvas--push')) {
      isOpenClass += ' is-offcanvas-push';
      if ($(menu).is('.off-canvas--right')) {
        isOpenClass += ' is-offcanvas-push-right';
      }
      if ($(menu).is('.off-canvas--small')) {
        isOpenClass += ' is-offcanvas-small';
      }
      if ($(menu).is('.off-canvas--medium')) {
        isOpenClass += ' is-offcanvas-medium';
      }
      if ($(menu).is('.small--off-canvas--full')) {
        isOpenClass += ' is-small-offcanvas-full';
      }
    }

    setTimeout(function openMenuTimeout() {
      $(menu).attr('aria-hidden', false);
      $('body').addClass(isOpenClass);
      setTimeout(function afterOpenTimeout() {
        afterOpen(menu);
      }, DIMMER_TRANS_LENGTH);
    }, 0);

    $focusEl = $(menu).find('.js-first-focus').first();

    if (!$focusEl.length) {
      $focusEl = $(menu).find('input, select, textarea').first();
    }
    if (!$focusEl.length) {
      $focusEl = $(menu).find('a.is-active').first();
    }
    if (!$focusEl.length) {
      $focusEl = $(menu).find('a').first();
    }
  }

  function toggleMenu(menu) {
    var isClosed = $(menu).attr('aria-hidden') === 'true';

    if (isClosed) {
      closeAllMenus();
      openMenu(menu);
    } else {
      closeMenu(menu);
    }
  }

  function addDimmer() {
    var $dimmer = $('<div class="off-canvas__dimmer" />');
    $('body').append($dimmer);
    $dimmer.on('click', function dimmerClick() {
      closeAllMenus();
    });
  }

  function initControls() {
    $menus.each(function initControlsLoop(index, menu) {
      var thisId = $(menu).attr('id');
      var $menuToggles = $('a[href="#' + thisId + '"]');

      $menuToggles.on('click', function menuTogglesClick(e) {
        e.preventDefault();
        toggleMenu(menu);
      });

      $(menu).on(
        'click',
        '.js-offcanvas-close',
        function offCanvasCloseClick(e) {
          e.preventDefault();
          closeMenu(menu);
        }
      );
    });
  }

  function init() {
    addDimmer();
    initControls();
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.closeAllMenus = closeAllMenus;
  window.rfd.closeMenu = closeMenu;
  window.rfd.openMenu = openMenu;
  window.rfd.toggleMenu = toggleMenu;
})();

/**
 * Module for showing alerts and modal/lightbox overlays.
 *
 * Alerts can be shown dynamically from anywhere in JS via:
 * window.rfd.alert(title, desc)
 *
 * Modals can be added by adding modal markup to the page, assigning .modal
 * a unique ID, then trigger by any link with an id="#modal-id"
 *
 * @exports window.rfd.modal.closeAll()
 * @exports window.rfd.modal.close()
 * @exports window.rfd.modal.open()
 * @exports window.rfd.modal.toggle()
 *
 * @requires snippets/modal-alert.liquid
 */

(function modalAlertFunction() {
  'use strict';

  var TRANS_LENGTH = 400;

  var selectors = {
    modal: '[data-modal]',
    modalInner: '.modal__inner',
    closeBtn: '.js-modal-close',
    bodyClassOpen: 'is-modal-open'
  };

  var $modals;

  function close(modal) {
    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.remove();
    }

    $('body').removeClass(selectors.bodyClassOpen);
    $(modal).attr('aria-hidden', true);

    setTimeout(function modalHideTimeout() {
      $(modal).addClass('hide');
    }, TRANS_LENGTH);

    // NOTE: DO NOT USE SLATE'S TRAPFOCUS UTILITY HERE, CAN THROW A MAXRANGE
    // ERROR WHICH CAN CRASH THE BROWSER (POTENTIALLY DURING CART CHANGES IF
    // "MAX QUANT" ERROR IS SHOWN)
  }

  function closeAll() {
    $modals
      .filter('[aria-hidden="false"]')
      .each(function modalClose(i, menu) {
        close(menu);
      });
  }

  function open(modal, closeAllModals = true) {
    var $focusEl = $(modal).find('.js-first-focus').first();

    if ($(modal).attr('aria-hidden') === 'false') {
      // early return if modal is already open
      return;
    }

    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.apply();
    }

    if (closeAllModals) {
      if (window.rfd && window.rfd.closeAllMenus) {
        window.rfd.closeAllMenus();
      }
    }

    $(modal).removeClass('hide');
    $(modal).attr('aria-hidden', false);

    setTimeout(function modalAddBodyClass() {
      $('body').addClass(selectors.bodyClassOpen);
    }, 0);

    if (!$focusEl.length) {
      $focusEl = $(modal)
        .find('input, select, textarea, button')
        .first();
    }
    if (!$focusEl.length) {
      $focusEl = $(modal).find('a.is-active').first();
    }
    if (!$focusEl.length) {
      $focusEl = $(modal).find('a').first();
    }

    // NOTE: DO NOT USE SLATE'S TRAPFOCUS UTILITY HERE, CAN THROW A MAXRANGE
    // ERROR WHICH CAN CRASH THE BROWSER (POTENTIALLY DURING CART CHANGES IF
    // "MAX QUANT" ERROR IS SHOWN)
  }

  function toggle(modal) {
    var isClosed = $(modal).attr('aria-hidden') === 'true';

    if (isClosed) {
      closeAll();
      open(modal);
    } else {
      close(modal);
    }
  }

  function initControls() {
    $modals.each(function modalsLoop(index, modal) {
      var thisId = $(modal).attr('id');
      var $modalToggles = $('a[href="#' + thisId + '"]');
      var $modalCloseBtns = $(modal).find(selectors.closeBtn);
      var $modalInner = $(modal).find(selectors.modalInner);

      if ('autoModal' in modal.dataset) {
        window.addEventListener('DOMContentLoaded', event => {
          if ('modalCookie' in modal.dataset) {
            if (
              document.cookie.indexOf(modal.dataset.modalCookie) == -1
            ) {
              document.cookie = modal.dataset.modalCookie + '=true';
              open(modal);
            }
          } else {
            open(modal);
          }
        });
      }

      $(modal).on('click', function modalClickClose() {
        // closes modal on clicking dimmer/overlay
        close(modal);
      });

      $modalInner.on('click', function modalDontClose(e) {
        // stop propagation so clicks in body don't close modal
        e.stopPropagation();
      });

      $modalToggles.on('click', function modalToggle(e) {
        e.preventDefault();
        toggle(modal);
      });

      $modalCloseBtns.on('click', function modalClickClose(e) {
        e.preventDefault();
        close(modal);
      });
    });
  }

  function showAlert(title, desc) {
    var $globalErr = $('#global-error');

    if (!$globalErr.length) {
      console.error('No alert HTML in DOM to display error:');
    }

    if (title) {
      if (title == 'Cart Error') {
        title = 'Oops!';
      }
      $globalErr.find('.modal__title').html('<h3>' + title + '</h3>');
    }
    if (desc) {
      $globalErr.find('.modal__body').html('<p>' + desc + '</p>');
    }

    open($globalErr);
    console.info('Alert:', title, desc);
  }

  function _init() {
    $modals = $(selectors.modal);

    if (!$modals.length) {
      return;
    }

    initControls();

    $modals.each(function modalNoScroll() {
      if (window.rfd && window.rfd.noscroll) {
        window.rfd.noscroll.contain(this);
      }
    });
  }

  _init();

  window.rfd.modal = {};
  window.rfd.modal.closeAll = closeAll;
  window.rfd.modal.close = close;
  window.rfd.modal.open = open;
  window.rfd.modal.toggle = toggle;
  window.rfd.alert = showAlert;
})();

/**
 * AJAX utility functions to enable/disable controls during requests,
 * and catch global errors.
 *
 * @exports window.rfd.enableBtns()
 * @exports window.rfd.disableBtns()
 */

(function ajaxUtilsFunction() {
  'use strict';

  var selectors = {
    control: '[data-ajax-ctrl]',
    controlTxt: '[data-ctrl-text]',
    activeControl: '[data-ajax-ctrl-active]',
    alwaysTxtChange: '[data-show-ajax-status]',
    cartCount: '[data-cart-item-count]',
    atcText: '[data-add-to-cart-text]',
    cartUpdate: 'Updating Cart'
  };

  var $controls = null;

  var origTxt = '';

  window.rfd = window.rfd || {};
  window.rfd.ajaxControlsDisabled = false;

  function handleRequestComplete(event, cart) {
    // update cart counts
    $(selectors.cartCount).html(cart.item_count);
  }

  function disable(activeBtn, loadStr, $customBtns) {
    var loadString = loadStr || theme.strings.addToCartProgress;
    var $sliders;

    // early return if controls already disabled. prevents duplicate calls which
    // can cause issues re-enablind
    if (window.rfd.ajaxControlsDisabled === true) {
      console.log('[ajax-utils] controls already disabled');
      return;
    }

    if (activeBtn) {
      $(activeBtn).attr('data-ajax-ctrl-active', true);
    }

    if (!$customBtns || !$customBtns.length) {
      $controls = $(selectors.control).filter(':not([disabled])');
    } else {
      $controls = $customBtns;
    }

    $controls.attr('disabled', 'disabled');

    origTxt = $controls
      .first()
      .find(selectors.atcText)
      .first()
      .text();

    $controls.find(selectors.atcText).text(selectors.cartUpdate);

    // custom disable for ionRangeSliders
    $sliders = $controls.filter('.range-slider');
    $sliders.siblings('.irs').attr('disabled', 'disabled');

    $controls.each(function controlsLoopOne(i, el) {
      var $txt = $(el).find(selectors.controlTxt);

      if (
        !$(el).is(selectors.alwaysTxtChange) &&
        !$(el).is(selectors.activeControl)
      ) {
        return;
      }

      if ($txt.length) {
        $txt.data('orig-text', $txt.text());
        $txt.text(loadString);
      }
    });

    window.rfd.ajaxControlsDisabled = true;
    console.log('[ajax-utils] disable controls');
  }

  function enable() {
    var $sliders;

    if (window.rfd.ajaxControlsDisabled === false) {
      console.log('[ajax-utils] controls already enabled');
      return;
    }

    console.log('[ajax-utils] enable controls');

    $controls.each(function controlsLoopTwo(i, el) {
      var $txt = $(el).find(selectors.controlTxt);

      if (
        !$(el).is(selectors.alwaysTxtChange) &&
        !$(el).is(selectors.activeControl)
      ) {
        return;
      }

      if ($txt.length) {
        $txt.text($txt.data('orig-text'));
      }
    });
    $controls
      .removeAttr('data-ajax-ctrl-active')
      .removeAttr('disabled');

    console.log(origTxt);

    $controls.find(selectors.atcText).text(origTxt);

    // custom enable for ionRangeSliders
    $sliders = $controls.filter('.range-slider');
    $sliders.siblings('.irs').removeAttr('disabled');

    window.rfd.ajaxControlsDisabled = false;
  }

  function handleAjaxError() {
    console.error('AJAX error, re-enabling checkout buttons.');
    enable();
  }

  function init() {
    $(document).on('cart.requestComplete', handleRequestComplete);
    $(document).ajaxError(handleAjaxError);
  }

  init();

  // export global utility functions
  window.rfd = window.rfd || {};
  window.rfd.disableBtns = disable;
  window.rfd.enableBtns = enable;
})();

/**
 * Handles adding to cart via AJAX (product forms + "Quick Add" buttons)
 *
 * @requires vendor/_cart.min.js
 */

(function cartAddFunction() {
  'use strict';

  var selectors = {
    singleOptionSelector: '[data-single-option-selector]',
    productForms: '[data-ajax-product-form]',
    quickAddBtns: '[data-quick-add-to-cart]',
    quickAddVariantIdAttr: 'data-quick-add-to-cart',
    quickAddHolder: '[data-quick-add-holder]'
  };

  /**
   * Takes product variant data and adds it/them to Shopify's cart via AJAX.
   * Multiple variants are added in sequence, in order they appear in array.
   *
   * @private
   * @param {Object|Object[]} data - CartJS data, or an array of CartJS data
   * @param {Number} data.variantId - Variant ID of product
   * @param {Number} data.quantity - Quantity of product
   * @param {Object} [data.customProperties] - Custom properties for cart line item
   * @param {Function} [callback] - Custom callback following completion
   */
  function ajaxAddToCart(data, callback) {
    Shopify.queue = [];

    // Vet data & add to queue
    if (data.variantId && data.quantity) {
      Shopify.queue.push(data);
    } else if (data.length) {
      data.forEach(function vetDataLoop(d) {
        if (d.variantId && d.quantity) {
          Shopify.queue.push(d);
        } else {
          console.error('[cart-add] invalid data', d);
        }
      });
    } else {
      console.error('[cart-add] invalid data', data);
      return;
    }

    // Process the queue
    Shopify.moveAlong = function processQueue() {
      var request;

      if (Shopify.queue.length) {
        request = Shopify.queue.shift();
        request.customProperties = request.customProperties || {};

        console.log('[cart-add] adding', request);
        document.dispatchEvent(
          new CustomEvent('minicart:add', {
            detail: request.variantId
          })
        );

        // Make AJAX submission
        CartJS.addItem(
          request.variantId,
          request.quantity,
          request.customProperties,
          {
            success: function cartAddAjaxSuccess(data) {
              Shopify.moveAlong();
            },
            error: function cartAddAjaxError(
              jqXHR,
              textStatus,
              errorThrown
            ) {
              console.timeEnd('[cart-add]');
              console.error(jqXHR, textStatus, errorThrown);

              if (window.rfd && window.rfd.enableBtns) {
                window.rfd.enableBtns();
              }

              if (
                window.rfd &&
                window.rfd.alert &&
                jqXHR.responseJSON &&
                jqXHR.responseJSON.message &&
                jqXHR.responseJSON.description
              ) {
                window.rfd.alert(
                  jqXHR.responseJSON.message,
                  jqXHR.responseJSON.description
                );
                $.magnificPopup.instance.close(); // Close popup that is currently opened
                window.rfd.renderCart(true, window.rfd.enableBtns); // Render minicart
              }
            }
          }
        );

        setTimeout(() => {
          const preorderPopup = document.querySelector('.preorder-popup');
          const isPreorderProduct = document.querySelector('[data-preorder]');
          const isInStockProduct = document.querySelector('[data-in-stock]');

          if (isPreorderProduct && isInStockProduct) {
            const preorderOpened = getCookies('preorder-popup-opened');
            if (preorderOpened !== null) return;
            window.rfd.modal.open(preorderPopup, false);
            preorderPopup.classList.toggle('is-open');
            setCookies('preorder-popup-opened', 'true', 1);
          }
        }, 3000)

      } else {
        console.timeEnd('[cart-add]');

        if (callback) {
          callback();
        } else {
          window.rfd.renderCart(false, window.rfd.enableBtns);
        }
      }
    };

    console.time('[cart-add]');
    Shopify.moveAlong();
  }

  /**
   * Gets variant data for CartJS from a Shopify product form
   *
   * @private
   * @param {jQuery} form - <form> element output by {% form 'product' %}
   * @returns {object|null} data for CartJS submission if found, or null
   */
  function getFormData(form) {
    var id = $(form).find('[name="id"]').first().val();

    var quant = $(form).find('[name="quantity"]').first().val();

    // Find custom property fields and add to object for CartJS use
    var customProperties = {};
    var $customPropFields = $(form).find('[name^="properties"]');

    id = parseInt(id, 10);

    if (!id) {
      console.error('[cart-add] no variant id', id);
      return null;
    }

    if (!quant) {
      quant = 1;
      console.info(
        '[cart-add] no quant found in DOM, defaulting to 1'
      );
    }

    $customPropFields.each(function cartAddPropLoop() {
      var propVal = $(this).val();
      var propName = $(this)
        .attr('name')
        .replace(/properties\[/gi, '')
        .replace(/\]/gi, '');

      customProperties[propName] = propVal;
    });

    return {
      variantId: id,
      quantity: quant,
      customProperties: customProperties
    };
  }

  /**
   * Adds a product to cart via AJAX when product form submitted.
   *
   */
  function handleProductFormSubmit(e) {
    var formData = getFormData(this);

    e.preventDefault();

    if (window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns(this);
    }

    if (formData) {
      ajaxAddToCart(formData);
    }
  }

  /**
   * Adds product(s) to cart via AJAX when "Quick Add" button clicked.
   */
  function handleQuickAddBtnClick(e) {
    var variantIds = $(this).attr(selectors.quickAddVariantIdAttr);
    var variantIdsArr = variantIds.split(',');
    var variantsData = [];

    var quantEl = $(this)
      .closest(selectors.quickAddHolder)
      .find('[name="quantity"]');
    var quant = 1;

    if (quantEl.length) {
      quant = quantEl.first().val();
    }

    e.preventDefault();

    if (!variantIds) {
      console.error('[cart-add] no variant IDs on add button');
      return;
    }

    variantIdsArr.forEach(function cartAddVariantLoop(id) {
      variantsData.push({
        quantity: quant,
        variantId: parseInt(id, 10)
      });
    });

    if (window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns(this);
    }

    ajaxAddToCart(variantsData);
  }

  /**
   * Adds gift wrap to cart via AJAX when "Quick Add" button clicked.
   */
  function handleGiftWrapBtnClick(e) {
    var variantIds = $(this).attr('data-add');
    var variantIdsArr = variantIds.split(',');
    var variantsData = [];
    let messageField = document.querySelector(
      '.js-gift-wrap-message'
    );
    let customProperty = {};

    if (messageField) {
      let message = messageField.value.trim();
      if (message.length > 0) {
        customProperty['Message'] = message;
      }
    }

    var quantEl = $(this)
      .closest(selectors.quickAddHolder)
      .find('[name="quantity"]');
    var quant = 1;

    if (quantEl.length) {
      quant = quantEl.first().val();
    }

    e.preventDefault();

    if (!variantIds) {
      console.error('[cart-add] no variant IDs on add button');
      return;
    }

    variantIdsArr.forEach(function cartAddVariantLoop(id) {
      variantsData.push({
        quantity: quant,
        variantId: parseInt(id, 10),
        customProperties: customProperty
      });
    });

    if (window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns(this);
    }

    ajaxAddToCart(variantsData);
  }

  function init() {
    $('body').on(
      'submit',
      selectors.productForms,
      handleProductFormSubmit
    );
    $('body').on(
      'click',
      selectors.quickAddBtns,
      handleQuickAddBtnClick
    );
    $('body').on(
      'click',
      '.js-add-gift-wrapping',
      handleGiftWrapBtnClick
    );
  }

  init();
})();

/**
 * Handles removing from cart via AJAX (minicart "Remove" buttons)
 *
 * @requires vendor/_cart.min.js
 */

(function cartRemoveFunction() {
  'use strict';

  var selectors = {
    cartForm: '[data-cart]',
    removeBtns: '[data-cart-remove]',
    lineNumberAttr: 'data-cart-remove',
    cartItem: '[data-cart-item]',
    singlePrice: 'data-item-single-price',
    itemTitle: 'data-item-title',
    itemSKU: 'data-item-sku',
    itemType: 'data-item-type',
    itemProdId: 'data-product-id'
  };

  /**
   * Removes a line item from the cart (optionally changing remove button state)
   *
   * @param {number} lineNumber - cart line item number to be removed
   * @param {jQuery} [removeBtn] - button to change state during operation
   */
  function ajaxRemoveFromCart(lineNumber, removeBtn) {
    console.time('[cart-remove]');
    console.log('[cart-remove] removing', lineNumber);

    if (removeBtn) {
      window.rfd.disableBtns(
        removeBtn,
        window.theme.strings.removing
      );
    }

    var $removeBtn = $(
      '[data-cart-remove="' + lineNumber + '"]',
      selectors.cartForm
    );
    var $quantBtn = $(
      '[data-item-quantity="' + lineNumber + '"]',
      selectors.cartForm
    );

    var $currentLineItem = $removeBtn.closest(selectors.cartItem);
    var currentLineItemVariantID =
      $currentLineItem.attr('data-variant-id');
    var currentLineItemTitle = $currentLineItem
      .find('input')
      .attr(selectors.itemTitle);
    var currentLineItemSKU = $currentLineItem
      .find('input')
      .attr(selectors.itemSKU);
    var currentLineItemType = $currentLineItem
      .find('input')
      .attr(selectors.itemType);
    var currentLineItemPrice =
      $currentLineItem.find('input').attr(selectors.singlePrice) /
      100;
    var currentLineItemProductID = $currentLineItem
      .find('input')
      .attr(selectors.itemProdId);

    document.dispatchEvent(
      new CustomEvent('minicart:remove', {
        detail: currentLineItemProductID
      })
    );

    CartJS.removeItem(lineNumber, {
      success: function cartRemoveSuccess() {
        console.timeEnd('[cart-remove]');
        window.rfd.renderCart(false, window.rfd.enableBtns);
      },
      error: function cartRemoveError(
        jqXHR,
        textStatus,
        errorThrown
      ) {
        console.error(jqXHR, textStatus, errorThrown);

        if (window.rfd && window.rfd.enableBtns) {
          window.rfd.enableBtns();
        }

        if (
          window.rfd &&
          window.rfd.alert &&
          jqXHR.responseJSON &&
          jqXHR.responseJSON.message &&
          jqXHR.responseJSON.description
        ) {
          window.rfd.alert(
            jqXHR.responseJSON.message,
            jqXHR.responseJSON.description
          );
        }
      }
    });
  }

  /**
   * Removes item from cart on button click
   */
  function handleRemoveClick(e) {
    var lineNumber = $(this).attr(selectors.lineNumberAttr);

    if (lineNumber) {
      e.preventDefault();
      ajaxRemoveFromCart(lineNumber, this);
    } else {
      console.error('[cart-remove] invalid line number', lineNumber);
    }
  }

  function init() {
    $('body').on('click', selectors.removeBtns, handleRemoveClick);
  }

  init();
})();

/**
 * Update cart in DOM via AJAX
 *
 * @exports window.rfd.renderCart()
 *
 * @requires vendor/cart.min.js
 * @requires _off-canvas.js
 */

(function cartRenderFunction() {
  'use strict';

  var selectors = {
    minicart: '#minicart',
    cartForm: '[data-cart]',
    alwaysStayClosed: 'body.template-cart'
  };

  var cartAjaxTemplate =
    window.Shopify.routes.root + 'cart?view=ajax';
  var cartPageTemplate =
    window.Shopify.routes.root + 'cart?view=cart-page';

  /**
   * Updates the DOM and re-fires JavaScript as necessary
   *
   * @param {boolean} dontOpen - whether to open minicart after updating
   * @param {function} callback - callback to fire after updating
   */
  function renderCart(dontOpen, callback) {
    var $cartEls = $(selectors.cartForm);
    var chosenCartTemplate = cartAjaxTemplate;
    if ($(selectors.alwaysStayClosed).length) {
      chosenCartTemplate = cartPageTemplate;
    }

    console.log('[cart-render] updating minicart');

    if (!$cartEls.length) {
      return;
    }

    console.time('[cart-render]');

    //console.log('FETCH');

    // fostr - reloads if on cart page
    if (window.location.pathname.includes('/cart')) {
      location.reload();
    }

    fetch(window.Shopify.routes.root + 'cart?view=ajax')
      .then(response => response.text())
      .then(responseText => {
        const data = responseText;
        //console.log(data)

        var doNotOpen = dontOpen;
        $(selectors.cartForm).replaceWith($(data));

        // Re-initialize the express buttons
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }

        // re-fire resposive images polyfill for IE11
        if (picturefill) {
          picturefill();
        }

        // re-initialise variant selectors
        if (window.rfd && window.rfd.initQuickAddVariants) {
          window.rfd.initQuickAddVariants();
        }
        // don't open minicart on cart template
        if ($(selectors.alwaysStayClosed).length) {
          doNotOpen = true;
        }

        if (doNotOpen !== true && window.rfd && window.rfd.openMenu) {
          // close any open modals
          if ($.magnificPopup) {
            $.magnificPopup.close();
          }

          // open the mini-cart
          window.rfd.openMenu(selectors.minicart);
        }

        // Hide mobile PCP quick buy
        $('.quick-buy-container.mqb-transition-in')
          .removeClass('mqb-transition-in')
          .addClass('soft-hide-mob');

        console.timeEnd('[cart-render]');

        if (callback) {
          callback();
        }

        var modal = document.getElementById('minicart');
        modal.focus();
      })
      .then(responseText => {
        document.dispatchEvent(
          new CustomEvent('minicart:render.complete')
        );
      });

    /*
		$.get(window.Shopify.routes.root + 'cart?view=ajax', function cartRenderAjax(data) {
			var doNotOpen = dontOpen;
			$(selectors.cartForm).replaceWith($(data));

			 //console.log(window.Shopify.routes.root + 'cart?view=ajax')

			// Re-initialize the express buttons
			if (window.Shopify && Shopify.StorefrontExpressButtons) {
				Shopify.StorefrontExpressButtons.initialize();
			}

			// re-fire resposive images polyfill for IE11
			if (picturefill) {
				picturefill();
			}

			// re-initialise variant selectors
			if (window.rfd && window.rfd.initQuickAddVariants) {
				window.rfd.initQuickAddVariants();
			}
			// don't open minicart on cart template
			if ($(selectors.alwaysStayClosed).length) {
				doNotOpen = true;
			}

			if (doNotOpen !== true && window.rfd && window.rfd.openMenu) {
				// close any open modals
				if ($.magnificPopup) {
					$.magnificPopup.close();
				}

				// open the mini-cart
				window.rfd.openMenu(selectors.minicart);
			}

			// Hide mobile PCP quick buy
			$('.quick-buy-container.mqb-transition-in').removeClass('mqb-transition-in').addClass('soft-hide-mob');

			console.timeEnd('[cart-render]');

			if (callback) {
				callback();
			}

			var modal = document.getElementById('minicart');
			modal.focus();
		}).done(() => {
			document.dispatchEvent(
				new CustomEvent("minicart:render.complete")
			);
		});
		*/
  }

  window.rfd.renderCart = renderCart;
})();

/**
 * Handles changing cart quantities via AJAX (minicart "Quantity" togglers)
 *
 * @requires vendor/_cart.min.js
 */

(function cartUpdateFunction() {
  'use strict';

  var selectors = {
    quant: '[data-item-quantity]',
    removeBtn: '[data-cart-remove]',
    cartItem: '[data-cart-item]',
    lineNumberAttr: 'data-item-quantity',
    currentQuantAttr: 'data-current-val',
    singlePrice: 'data-item-single-price',
    itemTitle: 'data-item-title',
    itemSKU: 'data-item-sku',
    itemType: 'data-item-type',
    itemProdId: 'data-product-id'
  };

  /**
   * Updates cart item to new quantity
   *
   * @param {number} lineNumber - cart line number to change
   * @param {number} newQuant - quantity to change to
   * @param {jQuery} [control] - element to show status text during AJAX
   */
  function updateQuant(lineNumber, newQuant, control) {
    console.time('[cart-update]');
    console.log(
      '[cart-update] updating #' + lineNumber + ' x ' + newQuant
    );

    if (control && window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns(control, window.theme.strings.updating);
    }

    var $currentLineItem = control.closest(selectors.cartItem);
    var currentLineItemVariantID =
      $currentLineItem.attr('data-variant-id');
    var currentLineItemProductID = $currentLineItem
      .find('input')
      .attr(selectors.itemProdId);
    var currentLineItemTitle = $currentLineItem
      .find('input')
      .attr(selectors.itemTitle);
    var currentLineItemSKU = $currentLineItem
      .find('input')
      .attr(selectors.itemSKU);
    var currentLineItemType = $currentLineItem
      .find('input')
      .attr(selectors.itemType);
    var currentLineItemPrice =
      $currentLineItem.find('input').attr(selectors.singlePrice) /
      100;

    CartJS.updateItem(
      lineNumber,
      newQuant,
      {},
      {
        success: function cartUpdateAjaxSuccess() {
          console.timeEnd('[cart-update]');
          if (window.rfd && window.rfd.renderCart) {
            window.rfd.renderCart(false, window.rfd.enableBtns);
          }
        },
        error: function cartUpdateAjaxError(
          jqXHR,
          textStatus,
          errorThrown
        ) {
          console.timeEnd('[cart-update]');
          console.error(jqXHR, textStatus, errorThrown);

          if (window.rfd && window.rfd.enableBtns) {
            window.rfd.enableBtns();
          }

          if (
            window.rfd &&
            window.rfd.alert &&
            jqXHR.responseJSON &&
            jqXHR.responseJSON.message &&
            jqXHR.responseJSON.description
          ) {
            window.rfd.alert(
              jqXHR.responseJSON.message,
              jqXHR.responseJSON.description
            );
          }
        }
      }
    );
  }

  /**
   * Checks quantity value and if valid, update via AJAX.
   */
  function handleQuantChange(e) {
    // get quantity info
    var $control = $(this);
    var oldQuant = parseInt(
      $control.attr(selectors.currentQuantAttr),
      10
    );
    var newQuant = parseInt($control.val(), 10);
    var maxQuant = $control.attr('max');
    var minQuant = $control.attr('min');
    var lineNumber = $control.attr(selectors.lineNumberAttr);

    // check for co-located "remove button", and pass this as the button to show
    // status during AJAX (quantity fields can't show status text well)
    var $removeBtn = $(this)
      .closest(selectors.cartItem)
      .find(selectors.removeBtn);

    e.preventDefault();

    if (maxQuant && newQuant > maxQuant) {
      console.log('[cart-update] hit max');
      newQuant = maxQuant;
    }
    if (minQuant && newQuant < minQuant) {
      console.log('[cart-update] hit min');
      newQuant = minQuant;
    }

    if (newQuant === oldQuant) {
      console.log('[cart-update] no quant change');
      return;
    }

    updateQuant(lineNumber, newQuant, $removeBtn);
  }

  function init() {
    $('body').on('change', selectors.quant, handleQuantChange);
  }

  init();
})();

/**
 * Sort filter tags
 *
 * @exports window.rfd.sortTags()
 */

(function tagSortFunction() {
  var selectors = {
    tagGroup: '[data-sort-group]',
    customSortAttr: 'data-sort-group',
    tagSort: '[data-sort]',
    tagSortValAttr: 'data-sort'
  };

  function sortTags() {
    var $tagGroups = $(selectors.tagGroup);

    $tagGroups.each(function tagGroupsLoop(index, g) {
      var $tagsToSort = $(g).find(selectors.tagSort);
      var sortIndexes = [];
      var sortIndexesLetters = [
        'XXXS',
        'XXS',
        'XS',
        'S',
        'S+',
        'S++',
        'S+++',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL'
      ];
      var customSortVals = $(this).attr(selectors.customSortAttr);
      var isCustomSort = customSortVals.length;
      var isNumeric = false;
      var isNonNumeric = false;
      var i;
      var j;
      var $nextTag;

      if (isCustomSort) {
        customSortVals = customSortVals.split(',');
        customSortVals = customSortVals.map(
          function customSortValsMap(x) {
            // normalise values to whitespce/lowercase
            return x.trim().toLowerCase();
          }
        );
      }

      if (!$tagsToSort.length) {
        return;
      }

      /* eslint-disable no-shadow */
      $tagsToSort.each(function tagsToSortLoop(index, t) {
        sortIndexes.push(
          parseFloat($(t).attr(selectors.tagSortValAttr), 10)
        );
      });
      /* eslint-enable no-shadow */

      // if at least one value is numeric, continue with sort
      sortIndexes.forEach(function sortIndexesLoop(val) {
        if ($.isNumeric(val)) {
          isNumeric = true;
        } else {
          isNonNumeric = true;
        }
      });

      if (isNumeric) {
        sortIndexes.sort(function sortIndexesSort(a, b) {
          return b - a;
        });

        for (i = 0; i < sortIndexes.length; i += 1) {
          $nextTag = $tagsToSort.filter(
            '[data-sort="' + sortIndexes[i] + '"]'
          );
          $(g).prepend($nextTag);
        }
      }

      if (isNonNumeric) {
        sortIndexes = isCustomSort
          ? customSortVals
          : sortIndexesLetters;
        // reverse loop
        for (j = sortIndexes.length - 1; j >= 0; j -= 1) {
          $nextTag = $tagsToSort.filter(
            '[data-sort="' +
              sortIndexes[j].toLowerCase() +
              '"], [data-sort="' +
              sortIndexes[j].toUpperCase() +
              '"]'
          );
          $(g).prepend($nextTag);
        }
      }
    });
  }

  function _init() {
    sortTags();
  }

  _init();

  window.rfd = window.rfd || {};
  window.rfd.sortTags = sortTags;
})();

/**
 * EXAMPLE
		observe(
				el,
				(inView, intersection) => {
						if (inView && options.triggerOnce) {
								// If it should only trigger once, unobserve the element after it's inView
								unobserve(intersection.target);
						}
				},
				options
		)
 */

const INSTANCE_MAP = new Map();
const OBSERVER_MAP = new Map();
const ROOT_IDS = new Map();
const defaultOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 0
};
let consecutiveRootId = 0;

/**
 * Generate a unique ID for the root element
 * @param root
 */
function getRootId(root = null) {
  if (!root) return '';
  if (ROOT_IDS.has(root)) return ROOT_IDS.get(root);
  consecutiveRootId += 1;
  ROOT_IDS.set(root, consecutiveRootId.toString());
  return `${ROOT_IDS.get(root)}_`;
}

/**
 * Monitor element, and trigger callback when element becomes inView
 * @param element {HTMLElement} Element to observe
 * @param callback {Function} Called with inView
 * @param options {Object} Intersection observer options
 * @param options.threshold {(number|Array<number>)} Number between 0 and 1, indicating how much of the element should be inView before triggering
 * @param options.root {HTMLElement}
 * @param options.rootMargin {string} The CSS margin to apply to the root element.
 */
function observe(element = null, callback = () => {}, options = {}) {
  if (!element) return;

  // Validate that the element is not being used in another observer instance
  if (INSTANCE_MAP.has(element)) {
    console.error(
      'Trying to observe',
      element,
      "but it's already being observed by another instance.\nMake sure the `element` is only used by a single observer instance.\n"
    );
    return;
  }

  // Merge defaultOptions with options
  const { root, rootMargin, threshold } = {
    ...defaultOptions,
    ...options
  };

  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  // An observer with the same options can be reused, so lets use this fact
  const observerId =
    getRootId(root) +
    (rootMargin
      ? `${threshold.toString()}_${rootMargin}`
      : threshold.toString());

  let observerInstance = OBSERVER_MAP.get(observerId);
  if (!observerInstance) {
    observerInstance = new IntersectionObserver(
      onIntersection,
      options
    );
    if (observerId) OBSERVER_MAP.set(observerId, observerInstance);
  }

  const instance = {
    callback,
    element,
    inView: false,
    observerId,
    observer: observerInstance,
    // Make sure we have the thresholds value. It's undefined on a browser like Chrome 51.
    thresholds:
      observerInstance.thresholds ||
      (Array.isArray(threshold) ? threshold : [threshold])
  };

  INSTANCE_MAP.set(element, instance);
  observerInstance.observe(element);

  return instance;
}

/**
 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
 * make sure to call this method.
 * @param element {HTMLElement} - Element to unobserve
 */
function unobserve(element = null) {
  if (!element) return;

  const instance = INSTANCE_MAP.get(element);
  if (!instance) return;

  const { observerId, observer } = instance;
  const { root } = observer;

  observer.unobserve(element);

  // Check if we are still observing any elements with the same options.
  let itemsLeft = false;

  // Check if we still have observers configured with the same root.
  let rootObserved = false;
  if (observerId) {
    INSTANCE_MAP.forEach((item, key) => {
      if (item && key !== element) {
        if (item.observerId === observerId) itemsLeft = true;
        if (item.observer.root === root) rootObserved = true;
      }
    });
  }

  if (!rootObserved && root) ROOT_IDS.delete(root);
  if (!itemsLeft && observer) {
    // No more elements to observe for threshold, disconnect observer
    observer.disconnect();
  }

  // Remove reference to element
  INSTANCE_MAP.delete(element);
}

/** Destroy all IntersectionObservers currently connected */
function destroy() {
  OBSERVER_MAP.forEach(observer => {
    observer.disconnect();
  });

  OBSERVER_MAP.clear();
  INSTANCE_MAP.clear();
  ROOT_IDS.clear();
  consecutiveRootId = 0;
}

/** @param {IntersectionObserverEntry[]} entries */
function onIntersection(entries = []) {
  entries.forEach(entry => {
    const { isIntersecting, intersectionRatio, target } = entry;
    const instance = INSTANCE_MAP.get(target);

    // Firefox can report a negative intersectionRatio when scrolling.
    if (instance && intersectionRatio >= 0) {
      const { thresholds } = instance.observer;

      // If threshold is an array, check if any of them intersects.
      // This just triggers the onIntersection event multiple times.
      // eslint-disable-next-line arrow-body-style
      let inView = thresholds.some(threshold => {
        return instance.inView
          ? intersectionRatio > threshold
          : intersectionRatio >= threshold;
      });

      if (isIntersecting !== undefined) {
        // If isIntersecting is defined, ensure that the element is actually intersecting.
        // Otherwise it reports a threshold of 0
        inView = inView && isIntersecting;
      }

      instance.inView = inView;
      instance.callback(inView, entry);
    }
  });
}

/*================ Modules ================*/
/**
 * Add .touchevents on demand (on first touch event).
 * This method is more reliable than Modernizr/relying on browser
 * reporting support for touch events.
 *
 */

$(function detectTouchEvents() {
  // on-demand touch class detection on top of Modernizr
  $('html').one('touchstart', function onTouchStart() {
    $('body').addClass('touchevents').removeClass('no-touchevents');
  });
});

/**
 * Form validation using the Constraint Validation JavaScript API
 *
 * To validate a form add [data-validate] to the <form> or its parent element,
 * then markup form fields using the native HTML5 API.
 *
 * (type, required, pattern, minlength/maxlength, min/max attributes, etc)
 *
 * Use "title" attribute on <input> to give it a unique error message, otherwise
 * the default messages below will be displayed after input in div.error-message
 *
 * Style invalid fields with input.error
 *
 * @see https://github.com/cferdinandi/bouncer
 */

(function formValidationFunction() {
  var selectors = {
    form: 'form[data-validate], [data-validate] form'
  };

  function _init() {
    var validate = new Bouncer(selectors.form, {
      // Classes & IDs
      fieldClass: 'error', // Applied to fields with errors
      errorClass: 'error-message', // Applied to the error message for invalid fields
      fieldPrefix: 'bouncer-field_', // If a field doesn't have a name or ID, one is generated with this prefix
      errorPrefix: 'bouncer-error_', // Prefix used for error message IDs

      // Patterns
      // Validation patterns for specific input types
      patterns: {
        email:
          /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$/,
        url: /^(?:(?:https?|HTTPS?|ftp|FTP):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/,
        number: /[-+]?[0-9]*[.,]?[0-9]+/,
        color: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
        date: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))/,
        time: /(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9])/,
        month: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2]))/
      },

      // Message Settings
      messageAfterField: true, // If true, displays error message below field. If false, displays it above.
      messageCustom: 'data-bouncer-message', // The data attribute to use for customer error messages
      messageTarget: 'data-bouncer-target', // The data attribute to pass in a custom selector for the field error location

      // Error messages by error type
      messages: {
        missingValue: {
          'checkbox':
            window.theme.strings.validate.messageMissingValueCheckbox,
          'radio':
            window.theme.strings.validate.messageMissingValueRadio,
          'select':
            window.theme.strings.validate.messageMissingValueSelect,
          'select-multiple':
            window.theme.strings.validate
              .messageMissingValueSelectMultiple,
          'default':
            window.theme.strings.validate.messageMissingValueDefault
        },
        patternMismatch: {
          email:
            window.theme.strings.validate.messagePatternMismatchEmail,
          url: window.theme.strings.validate
            .messagePatternMismatchUrl,
          number:
            window.theme.strings.validate
              .messagePatternMismatchNumber,
          color:
            window.theme.strings.validate.messagePatternMismatchColor,
          date: window.theme.strings.validate
            .messagePatternMismatchDate,
          time: window.theme.strings.validate
            .messagePatternMismatchTime,
          month:
            window.theme.strings.validate.messagePatternMismatchMonth,
          default:
            window.theme.strings.validate
              .messagePatternMismatchDefault
        },
        outOfRange: {
          over: window.theme.strings.validate.messageOutOfRangeOver,
          under: window.theme.strings.validate.messageOutOfRangeUnder
        },
        wrongLength: {
          over: window.theme.strings.validate.messageWrongLengthOver,
          under: window.theme.strings.validate.messageWrongLengthUnder
        }
      },

      // Form Submission
      disableSubmit: false, // If true, native form submission is suppressed even when form validates

      // Custom Events
      emitEvents: true // If true, emits custom events
    });
  }

  _init();
})();

/**
 * Module for product quantity selectors with custom +/- buttons
 *
 */

(function productQuantityFunction() {
  var selectors = {
    input: '[data-quant-input]',
    select: '[data-quant-select]',
    minus: '[data-quant-minus]',
    plus: '[data-quant-plus]',
    quickAddInput: '[data-quick-add-holder] [data-quant-input]'
  };

  /**
   * Adjusts quant input by the given amount.
   *
   * @param {object} adjustCtrl - DOM element with '[data-for]' attribute
   * @param {number} amount - positive/negative integer to adjust amount by
   * @returns {undefined} undefined
   */
  function adjustVal(adjustCtrl, amount) {
    var fieldSelector = $(adjustCtrl).attr('data-for');
    var $field = $(adjustCtrl)
      .closest('form')
      .find(selectors.input)
      .filter(fieldSelector)
      .first();
    var minVal = parseInt($field.attr('min'), 10);
    var maxVal = parseInt($field.attr('max'), 10);
    var currentVal = parseInt($field.val(), 10);
    var newVal = currentVal + amount;

    // for unavailable products where "maxVal" might be 0
    if (minVal > maxVal) {
      maxVal = minVal;
    }

    if ($field.prop('disabled') === true) {
      console.log('Quant disabled');
      return;
    }

    if (!Number.isNaN(minVal) && newVal < minVal) {
      console.log('Quant prevented from going below min');
      return;
    }

    if (!Number.isNaN(maxVal) && newVal > maxVal) {
      console.log('Quant prevented from exceeding max');
      return;
    }

    if (currentVal === newVal) {
      console.log('No quant change');
      return;
    }

    if (Number.isNaN(newVal)) {
      return;
    }

    $(adjustCtrl)
      .closest('form')
      .find(fieldSelector)
      .val(newVal)
      .trigger('change');
  }

  /**
   * Updates all quantity inputs when one changes, capping at max/min vals
   *
   * @param {object} event - event object
   * @param {booleam} isSelect - adjust behaviour for selects (which can't take arbitrary integers)
   * @returns {undefined} undefined
   */
  function handleValChange(event, isSelect) {
    var maxVal = parseInt($(this).attr('max'), 10);
    var minVal = parseInt($(this).attr('min'), 10);
    var newVal = parseInt($(this).val(), 10);

    // console.log(
    //   'isSelect',
    //   isSelect,
    //   'minVal',
    //   minVal,
    //   'maxVal',
    //   maxVal,
    //   'newVal',
    //   newVal
    // );

    if (
      !isSelect &&
      maxVal &&
      !Number.isNaN(maxVal) &&
      newVal > maxVal
    ) {
      console.log('Quant set to max');
      newVal = maxVal;
    }

    if (
      !isSelect &&
      minVal &&
      !Number.isNaN(minVal) &&
      newVal < minVal
    ) {
      console.log('Quant set to min');
      newVal = minVal;
    }

    $(this).closest('form').find(selectors.input).val(newVal);
  }

  function handleMinusClick(e) {
    e.preventDefault();
    adjustVal(this, -1);
  }

  function handlePlusClick(e) {
    e.preventDefault();
    adjustVal(this, 1);
  }

  /**
   * Prevents clicking on quant picker going to PDP due to parent <a>
   */
  function handleQuickAddClick(e) {
    e.preventDefault();
  }

  function init() {
    $(selectors.quickAddInput).on('click', handleQuickAddClick);
    $(selectors.input).on('change', handleValChange);
    $(selectors.select).on('change', function (e) {
      handleValChange.call(this, e, true);
    });
    $('body').on('click', selectors.minus, handleMinusClick);
    $('body').on('click', selectors.plus, handlePlusClick);
  }

  init();
})();

/**
 * Module for accordion menu.
 *
 */

(function menuAccordionFunction() {
  var selectors = {
    menu: '.menu-accordion',
    item: '.menu-accordion__item',
    submenu: '.menu-accordion__submenu',
    links: '.menu-accordion__item.has-submenu > .menu-accordion__link'
  };

  if (!$(selectors.menu).length) {
    return;
  }

  var ANIM_LENGTH_MS = 200;

  function handleLinkClick(e) {
    e.preventDefault();

    var $accordion = $(this).closest(selectors.menu);
    var $item = $(this).closest(selectors.item);
    var $submenu = $(this).siblings(selectors.submenu);
    var isOpen = $item.hasClass('is-open');

    if (isOpen) {
      // close clicked accordion items
      $submenu.slideUp(ANIM_LENGTH_MS);
      $item.removeClass('is-open');
    } else {
      // close open accordion items
      $accordion
        .find(selectors.item)
        .filter('.is-open')
        .removeClass('is-open')
        .find(selectors.submenu)
        .slideUp(ANIM_LENGTH_MS);
      // open clicked accordion item
      $submenu.slideDown(ANIM_LENGTH_MS);
      $item.addClass('is-open');
    }
  }

  function initAccordion() {
    $(this).find(selectors.links).on('click', handleLinkClick);
  }

  function _init() {
    var $menus = $(selectors.menu);
    $menus.each(initAccordion);
  }

  _init();
})();

window.theme.mediaQuery = (function mediaQuery() {
  var breakpoints = {
    xsmall: 375,
    small: 550,
    medium: 768,
    large: 990,
    widescreen: 1400
  };

  var mediaStrings = {
    'xxsmall': '(max-width: ' + (breakpoints.xsmall - 1) + 'px)',
    'small': '(max-width:  ' + (breakpoints.medium - 1) + 'px)',
    'medium-up': '(min-width: ' + breakpoints.medium + 'px)',
    'large-up': '(min-width: ' + breakpoints.large + 'px)',
    'widescreen': '(min-width: ' + breakpoints.widescreen + 'px)'
  };
  /**
   * Tests a Slate-formatted media query label
   *
   * @param {string} label - the media query to test e.g. 'medium-up'
   * @return {boolean} whether the MQ matches
   */
  function test(label) {
    var string = mediaStrings[label];

    if (!string) {
      return false;
    }

    return window.matchMedia(string).matches;
  }

  return test;
})();

/**
 * Match height module.
 *
 */

(function modMatchHeight() {
  function init() {
    $('.resize-wrap').each(function resizeMe() {
      $(this).find('.resize-me').matchHeight();
    });
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.resizeMe = init;
})();

/**
 * Lazy-loaded pagination via Infinite Scroll
 *
 * @see https://infinite-scroll.com/options.html
 * @requires vendor/infinite-scroll.pkgd.min.js
 * @exports window.rfd.lazyPagReinit()
 */

(function lazyPagFunction() {
  var selectors = {
    grid: '[lazy-pag-grid]',
    next: '[lazy-pag-next]',
    pag: '[lazy-pag-pag]',
    item: '[lazy-pag-item]'
  };

  var $container;

  function swiperInit() {
    document
      .querySelectorAll('.swiper-container')
      .forEach(container => {
        const swiper = new Swiper(container, {
          // Optional parameters
          direction: 'horizontal',
          loop: true,

          // If we need pagination
          pagination: {
            el: '.swiper-pagination'
          },

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });
      });
  }

  function init() {
    if (!$(selectors.next).length) {
      swiperInit();
      console.log('[lazy-pag] no next (disabled)');
      return;
    }

    if (!$(selectors.grid).length) {
      console.log('[lazy-pag] no grid (disabled)');
      return;
    }

    swiperInit();

    $container = $(selectors.grid).infiniteScroll({
      append: selectors.item,
      path: selectors.next,
      hideNav: selectors.pag,
      checkLastPage: true,
      history: false,
      scrollThreshold: 800, // px from bottom to trigger load (default: 400)
      status: '.page-load'
    });

    // @see https://infinite-scroll.com/events.html
    $container.on(
      'append.infiniteScroll',
      function lazyPagAppend(event, response, path, items) {
        var sections;

        console.log('[lazy-pag] appended ' + items.length);

        $('.resize-wrap').each(function resizeMe() {
          $(this).find('.resize-me').matchHeight();
        });

        // Rerun product.js so product form in collection grid works
        sections = new slate.Sections();
        sections.register('product', theme.Product);

        // Rerun coming soon countdown JS
        if (window.rfd && window.rfd.initComingSoonCountdowns) {
          window.rfd.initComingSoonCountdowns();
        }

        // Rerun lightning countdown JS
        if (window.rfd && window.rfd.initLightningCountdowns) {
          window.rfd.initLightningCountdowns();
        }

        swiperInit();
      }
    );

    $container.on(
      'request.infiniteScroll',
      function lazyPagRequest(event, path) {
        console.log('[lazy-pag] loading page: ' + path);
      }
    );

    $container.on('last.infiniteScroll', function lazyPagLast() {
      console.log('[lazy-pag] last page loaded');
      $('.page-load').hide();
    });
  }

  /**
   * Reinitialises lazy pag.
   * Exported as global function below to call from anywhere. Useful when pag
   * links have been manually updated e.g. filters change results.
   */
  function reinit() {
    if ($container && $container.data('infiniteScroll')) {
      $container.infiniteScroll('destroy');
    }
    init();
    console.log('[lazy-pag] reinit');
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.lazyPagReinit = reinit;
})();

/**
 * Cookie banner.
 *
 */

if (window.theme.cookieBanner.enabled === 'true') {
  $(document).ready(function buildCookieBanner() {
    $('body').ihavecookies({
      title: '',
      message: window.theme.cookieBanner.message,
      acceptBtnLabel: 'X',
      delay: 0,
      expires: 30,
      link: '',
      onAccept: function acceptCookies() {
        $('body').removeClass('has-cookie-banner');

        // allows JS-based heights to adjust (e.g. full-height)
        $(window).trigger('resize');
      },
      uncheckBoxes: true
    });
  });
}

/**
 * Push page content down if cookie banner is visible
 *
 */

(function cookieBannerPosition() {
  function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    var i;
    var c;
    for (i = 0; i < ca.length; i += 1) {
      c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  if (!getCookie('cookieControl')) {
    $('body').addClass('has-cookie-banner');
  }
})();

/**
 * Module to lazy load video.
 *
 * Add 'lazy' class to video tag. Switch src to data-src
 *
 */

(function lazyVideoFunction() {
  var selectors = {
    video: 'video.lazy'
  };

  if (!$(selectors.video).length) {
    return;
  }

  function _init() {
    $(selectors.video).onScreen({
      doIn: function videoAddSrc() {
        var $video = $(this);
        var $sourceFile = $video.children('source').attr('data-src');

        $video.children('source').attr('src', $sourceFile);

        $video[0].load();
        $video[0].play();
      },
      tolerance: -200
    });
  }

  _init();
})();

/**
 * Module to update max value on product quantity depending on variant selected.
 *
 */

(function productInventoryFunction() {
  var selectors = {
    singleOptionSelector: '[data-single-option-selector]',
    originalSelectorId: '[data-product-select]',
    input: '.product-quantity__num',
    inventoryDisplay: '[inventory-display]', // For Jack1t's inventory display
    showInventory: 'data-threshold',
    inventoryDisplayNumber: '[inventory-display-number]',
    inventoryMessage: '.variant-inventory__message',
    inventoryLastOne: '.variant-inventory__last-one',
    progressBar: '.progress-bar__progress'
  };

  var $inventoryDisplay = $(selectors.inventoryDisplay);
  var showInventory = $inventoryDisplay.attr(selectors.showInventory);

  function inventoryDisplayUpdate(currentInventory) {
    var progress;

    if (showInventory > currentInventory) {
      if (currentInventory === 1) {
        $(selectors.inventoryMessage).addClass('hide');
        $(selectors.inventoryLastOne).removeClass('hide');
      } else {
        $(selectors.inventoryMessage).removeClass('hide');
        $(selectors.inventoryLastOne).addClass('hide');
      }

      $(selectors.inventoryDisplayNumber).text(currentInventory);
      progress = Math.floor((currentInventory / showInventory) * 100);
      $(selectors.progressBar).css('width', progress + '%');

      $inventoryDisplay.slideDown();
    } else {
      $inventoryDisplay.slideUp();
    }
  }

  function handleValChange() {
    var $closestForm = $(this).closest('form');

    setTimeout(function productInventoryTimeout() {
      var $selectedVariant = $closestForm.find(
        selectors.originalSelectorId + ' option:selected'
      );

      var $variantInventory = $selectedVariant.data('max');

      if ($selectedVariant.data('max')) {
        $selectedVariant
          .closest('form')
          .find($(selectors.input))
          .attr('max', $variantInventory);

        if (
          $selectedVariant
            .closest('form')
            .find($(selectors.input))
            .val() > $variantInventory
        ) {
          console.log('Too many');
          $selectedVariant
            .closest('form')
            .find($(selectors.input))
            .val($variantInventory);
        }

        inventoryDisplayUpdate($variantInventory);
      } else {
        $selectedVariant
          .closest('form')
          .find($(selectors.input))
          .removeAttr('max');

        $inventoryDisplay.slideUp();
      }
    }, 50);
  }

  function _init() {
    $(selectors.singleOptionSelector).on('change', handleValChange);

    // Trigger ATC button when only one option is present.
    setTimeout(() => {
      document
        .querySelector('[data-only-option]')
        .dispatchEvent(new Event('change', { bubbles: true }));
    }, 1000);
  }

  _init();
})();

/**
 * Toggles <video> src conditionally based on data attributes to
 * prevent wasted bandwidth when hidden.
 *
 * @requires vendor/lodash.throttle.js
 */

(function modVideoRespSrc() {
  var THROTTLE_WAIT_MS = 250;

  var selectors = {
    mediumUp: '[data-medium-up--src]'
  };

  var mediumUp = 'only screen and (min-width: 768px)';

  function checkSrcs() {
    var $mediumUp;

    if (window.matchMedia(mediumUp).matches) {
      $mediumUp = $(selectors.mediumUp);

      $mediumUp.each(function eachMediumUp() {
        var src = $(this).attr('data-medium-up--src');
        var $video = $(this).closest('video');

        if (!$video.length || !src) {
          return;
        }

        $(this).attr('src', src).removeAttr('data-medium-up--src');

        $video[0].load();
        // eslint-disable-next-line no-console
        console.log('[video-responsive-src] loaded video src');
      });
    }
  }

  function init() {
    checkSrcs();
    $(window).on(
      'resize',
      window.throttle(checkSrcs, THROTTLE_WAIT_MS)
    );
  }

  init();
})();

(function modRegisterBirthday() {
  function init() {
    var $daySelect = $('#birthday-day');
    var $monthSelect = $('#birthday-month');
    var $yearSelect = $('#birthday-year');
    var $bdayInput = $('#birthday-date');
    var $bdayTag = $('#birthday-date-tag');

    function updateBday() {
      var day = $daySelect.val();
      var month = $monthSelect.val();
      var year = $yearSelect.val();
      var error = document.getElementById('birthday-block-error');

      if (day !== 'day' && month !== 'month' && year !== 'year') {
        if (day.length === 1) {
          day = '0' + day.toString();
        }
        if (month.length === 1) {
          month = '0' + month.toString();
        }

        const bday_string =
          month.toString() +
          '/' +
          day.toString() +
          '/' +
          year.toString();
        const bday_obj = new Date(bday_string);
        const bday_check = bday_obj.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });

        if (bday_string == bday_check) {
          error.style.display = 'none';
          $daySelect.css('border-color', '#ccc');
          $monthSelect.css('border-color', '#ccc');
          $yearSelect.css('border-color', '#ccc');
          $bdayInput.val(
            year.toString() +
              '/' +
              month.toString() +
              '/' +
              day.toString()
          );
          $bdayTag.val(
            'DOB:' +
              day.toString() +
              '/' +
              month.toString() +
              '/' +
              year.toString()
          );
        } else {
          error.style.display = 'block';
          $daySelect.css('border-color', 'red');
          $monthSelect.css('border-color', 'red');
          $yearSelect.css('border-color', 'red');
          $daySelect.val('Day');
          $monthSelect.val('Month');
          $yearSelect.val('Year');
          $bdayInput.val('');
          $bdayTag.val('');
        }
      }
    }

    $('#birthday-day, #birthday-month, #birthday-year').on(
      'change',
      function handleChange() {
        updateBday();
      }
    );
  }

  $(document).ready(init);
})();

/**
 * Fixes iOS 100vh calculations to take into account address bar
 *
 * @requires jQuery
 * @requires vendor/lodash.throttle.js
 * @requires modules/_media-query.js
 *
 */

(function modFullHeight() {
  var THROTTLE_WAIT_MS = 300;
  var lastInnerWidth = null;

  var selectors = {
    fixEls: '[data-full-height-fix]',
    fullHeight: '.full-height',
    minusHeader: '.full-height-minus-header',
    mediumUpMinusHeader: '.medium-up--full-height-minus-header',
    largeUpAlmost: '.large-up--full-height-almost',
    largeUpThreeQuarter: '.large-up--three-quarter-height',
    smallMinusHeader: '.small--full-height-minus-header'
  };

  /**
   * Sets heights on elements based on window.innerHeight
   *
   * @return undefined
   */
  function setHeights() {
    // only set heights again when the page width has changed, to prevent scroll
    // jank on iOS when only the address bar changes 100vh during scroll,
    // resulting in tug of war between user scroll dir. & height adjustment when
    // user quickly srolls up & down
    if (
      lastInnerWidth !== null &&
      lastInnerWidth === window.innerWidth
    ) {
      return;
    }

    lastInnerWidth = window.innerWidth;

    $(selectors.fixEls).each(function eachEl() {
      var $el = $(this);
      var correctFullHeight = window.innerHeight; // 100vh
      var almostFullHeight = Math.round(window.innerHeight * 0.85); // 85vh
      var threeQuarterHeight = Math.round(window.innerHeight * 0.75); // 75vh
      var headerHeight = $('.site-header').outerHeight();

      var isFullHeight = $el.is(selectors.fullHeight);
      var isFullHeightMinusHeader = $el.is(selectors.minusHeader);
      var isMediumUpMinusHeader = $el.is(
        selectors.mediumUpMinusHeader
      );
      var isLargeUpAlmost = $el.is(selectors.largeUpAlmost);
      var isLargeUpThreeQuarter = $el.is(
        selectors.largeUpThreeQuarter
      );
      var isSmallMinusHeader = $el.is(selectors.smallMinusHeader);

      if (window.theme.mediaQuery('widescreen')) {
        correctFullHeight = almostFullHeight;
      }

      if (isFullHeight) {
        $el.css({ minHeight: correctFullHeight });
      }
      if (isFullHeightMinusHeader) {
        $el.css({ minHeight: correctFullHeight - headerHeight });
      }
      if (isMediumUpMinusHeader) {
        if (window.theme.mediaQuery('medium-up')) {
          $el.css({ minHeight: correctFullHeight - headerHeight });
        } else {
          $el.css({ minHeight: '' });
        }
      }
      if (isSmallMinusHeader) {
        if (window.theme.mediaQuery('small')) {
          $el.css({ minHeight: correctFullHeight - headerHeight });
        } else {
          $el.css({ minHeight: '' });
        }
      }
      if (isLargeUpAlmost) {
        if (window.theme.mediaQuery('large-up')) {
          $el.css({ minHeight: almostFullHeight - headerHeight });
        } else {
          $el.css({ minHeight: '' });
        }
      }
      if (isLargeUpThreeQuarter) {
        if (window.theme.mediaQuery('large-up')) {
          $el.css({ minHeight: threeQuarterHeight - headerHeight });
        } else {
          $el.css({ minHeight: '' });
        }
      }
    });
  }

  /**
   * Initialise module
   *
   * @return undefined
   */
  function init() {
    var $els = $(selectors.fixEls);

    if (!$els) {
      return;
    }

    $(window).on(
      'resize',
      window.throttle(setHeights, THROTTLE_WAIT_MS)
    );

    setHeights();
  }

  $(document).ready(init);
})();

/**
 * Activate :active states for buttons & links
 *
 */

(function mobileActiveStates() {
  function init() {
    if (document.addEventListener && true) {
      // enables :active states on mobile safari
      document.addEventListener('touchstart', function () {}, false);
    }

    // adds class confirming touch event support (for use in CSS)
    document.addEventListener(
      'touchstart',
      function addtouchclass(e) {
        document.documentElement.classList.add('is-touch');
        document.removeEventListener(
          'touchstart',
          addtouchclass,
          false
        );
      },
      false
    );
  }

  init();
})();

/**
 * Module to render cart when using the browser back button
 *
 */

(function reloadFunction() {
  var selectors = {
    cartCount: '[data-cart-item-count]'
  };

  window.onpageshow = function (event) {
    if (event.persisted) {
      window.rfd.renderCart(true, window.rfd.enableBtns);
      $(selectors.cartCount).html(window.theme.cartJSON.item_count);
      console.log('[Event persisted] render cart');
      window.location.reload();
    }
  };

  if (performance.navigation.type == 2) {
    window.rfd.renderCart(true, window.rfd.enableBtns);
    $(selectors.cartCount).html(window.theme.cartJSON.item_count);
    console.log('[Navigation type 2] render cart');
    window.location.reload();
  }
})();

('use strict');

/**
 * Carousels
 *
 */

(function mod() {
  function glideHandleHeight(el) {
    const activeSlide = el.querySelector('.glide__slide--active');
    const activeSlideHeight = activeSlide
      ? activeSlide.offsetHeight
      : 0;
    const glideTrack = el.querySelector('.glide__track');
    const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;

    if (activeSlideHeight !== glideTrackHeight) {
      glideTrack.style.height = activeSlideHeight + 'px';
    }
  }

  function makeCarousel(selector, options) {
    const carousels = [].slice.call(
      document.querySelectorAll(selector)
    );

    if (!Array.isArray(carousels) || !carousels.length) return null;

    const glideCarousels = carousels.map(carousel => {
      // NOTE: if there are no slides inside the carousel, the browser will crash on
      // Glide init, so we have to check for that case and early exit
      if (!carousel.querySelectorAll('.glide__slide').length) {
        console.error('Empty carousel!', carousel);
        return;
      }

      const glideCarousel = new Glide(carousel, options);

      // Automated height on Carousel build and change
      if (options.autoHeight) {
        glideCarousel.on('build.after', () =>
          glideHandleHeight(carousel)
        );
        glideCarousel.on('run.after', () =>
          glideHandleHeight(carousel)
        );
      }

      glideCarousel.mount();

      glideCarousel.on('move', function (movement) {
        const $carouselWidth = $(carousel)
          .find('.glide__slides')
          .width();
        const moveAmount = movement.movement;
        const movementPercentage =
          (moveAmount / $carouselWidth) * 100;
        carousel.style.setProperty(
          '--movement',
          movementPercentage + '%'
        );
      });

      glideCarousel.on('move.after', function (movement) {
        const $carouselWidth = $(carousel)
          .find('.glide__slides')
          .width();
        const moveAmount = movement.movement;
        const movementPercentage =
          (moveAmount / $carouselWidth) * 100;
        carousel.style.setProperty(
          '--movement',
          movementPercentage + '%'
        );
      });

      return glideCarousel;
    });

    return glideCarousels;
  }

  function initAjaxCarousels() {
    makeCarousel('.glide.product-carousel--ajax', {
      type: 'slider',
      perView: 4,
      rewind: false,
      bound: true,
      gap: 5,
      breakpoints: {
        989: {
          perView: 1.5
        }
      }
    });
  }

  function init() {
    makeCarousel('.glide.announcement-bar__carousel', {
      type: 'carousel',
      perView: 1,
      autoplay: 3000,
      swipeThreshold: true,
      dragThreshold: true,
      keyboard: false
    });

    makeCarousel('.glide.hero__carousel', {
      type: 'carousel',
      perView: 1,
      autoplay: 9000,
      swipeThreshold: true,
      dragThreshold: true,
      keyboard: false,
      gap: 0
    });

    makeCarousel(
      '.glide.carousel-hero-thumbs:not(.glide--carousel)',
      {
        type: 'carousel',
        perView: 1,
        gap: 0
      }
    );

    makeCarousel('.glide.related-colours:not(.glide--carousel)', {
      type: 'slider',
      perView: 5,
      rewind: false,
      bound: true,
      gap: 5,
      breakpoints: {
        989: {
          perView: 5.2
        }
      }
    });

    makeCarousel(
      '.glide.carousel-buy-this-look:not(.glide--carousel)',
      {
        type: 'slider',
        perView: 1,
        rewind: false,
        bound: true,
        gap: 5,
        animationDuration: 300,
        breakpoints: {
          989: {
            perView: 1.5
          }
        }
      }
    );

    makeCarousel('.glide.product-carousel', {
      type: 'slider',
      perView: 4,
      rewind: false,
      bound: true,
      gap: 5,
      breakpoints: {
        989: {
          perView: 1.5
        }
      }
    });
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.initAjaxCarousels = initAjaxCarousels;
})();

/**
 * Animate scrolling to elements (typically used for local anchor scrolling)
 *
 */

(function mod() {
  const SCROLL_SPEED_MS = 350;
  // leave this amount of whitespace in px above scrolled el
  const OFFSET_MARGIN_PX = 10;

  var selectors = {
    scrollEl: '[data-scroll-to]'
  };

  function init() {
    const scrollToEls = document.querySelectorAll(selectors.scrollEl);

    scrollToEls.forEach(function (el) {
      const href = el.getAttribute('href');
      const dataAttr = el.dataset.scrollTo;
      const scrollToSelector = dataAttr ? dataAttr : href;
      const scrollToEl = document.querySelector(scrollToSelector);

      if (!scrollToEl) {
        return;
      }

      el.addEventListener('click', function (e) {
        e.preventDefault();

        const scrollTarget = scrollToEl.offsetTop - OFFSET_MARGIN_PX;

        $('html, body').animate(
          {
            scrollTop: scrollTarget
          },
          SCROLL_SPEED_MS
        );
      });
    });
  }

  $(document).ready(init);
})();

/**
 * Module for mobile menu.
 *
 */

(function menuAccordionFunction() {
  var selectors = {
    menu: '.mobile-accordion',
    item: '.mobile-accordion__item',
    submenu: '.mobile-accordion__submenu',
    links:
      '> .mobile-accordion__item.has-submenu > .mobile-accordion__link'
  };

  var ANIM_LENGTH_MS = 200;

  function handleLinkClick(e) {
    e.preventDefault();

    var $accordion = $(this).closest(selectors.menu);
    var $item = $(this).closest(selectors.item);
    var $submenu = $(this).siblings(selectors.submenu);
    var isOpen = $item.hasClass('is-open');

    if (isOpen) {
      // close clicked accordion items
      $submenu.slideUp(ANIM_LENGTH_MS);
      $item.removeClass('is-open');
    } else {
      // close open accordion items
      $accordion
        .find(selectors.item)
        .filter('.is-open')
        .removeClass('is-open')
        .find(selectors.submenu)
        .slideUp(ANIM_LENGTH_MS);
      // open clicked accordion item
      $submenu.slideDown(ANIM_LENGTH_MS);
      $item.addClass('is-open');
    }
  }

  function initAccordion() {
    $(this).find(selectors.links).on('click', handleLinkClick);
  }

  function _init() {
    var $menus = $(selectors.menu);
    $menus.each(initAccordion);
  }

  _init();
})();

/**
 * Social share - toggle share options
 *
 */

(function modShare() {
  var selectors = {
    clicker: '.pdp-share__clicker',
    options: '.pdp-share__options'
  };

  const clicker = document.querySelector(selectors.clicker);
  const options = document.querySelector(selectors.options);

  if (clicker === null) return;

  clicker.onclick = () => options.classList.toggle('open');
})();

/**
 * Mega menu.
 *
 */

(function megaMenuFunction() {
  var $siteHeader = $('.site-header');
  var $menuNavItem = $('.site-nav li .menu__link');
  var $menuHolder = $('.mega-menu');
  var $menuNavHolder = $('.mega-menu__section');
  var menuPromoID;
  var $menuPromoCurrentTrigger;
  var $menuPromoCurrentTarget;
  var eventTarget;
  var ANIM_LENGTH_MS = 200;

  var pointerPosition = function megaMenuPointerPosition(item) {
    var menu;

    if (!$menuHolder.hasClass('is-active')) {
      $menuNavHolder
        .css({ 'display': 'none', 'z-index': 1 })
        .removeClass('is-visible');
      $(item).addClass('is-open');

      if ($(item).parent().data('attach') != null) {
        menu = '.menu-' + $(item).parent().data('attach');
      } else {
        menu = '.menu-' + ($(item).parent().index() + 1);
      }

      $menuHolder.css({
        height: 'auto'
      });

      $(menu)
        .css({ 'display': 'block', 'z-index': 5 })
        .addClass('is-visible');
    }
  };

  if ($('html').hasClass('touchevents')) {
    $('.site-nav li .menu__link').on(
      'click',
      function megaMenuTouchevents(e) {
        if ($(this).parent().hasClass('contain-mega')) {
          e.preventDefault();
          if ($(this).hasClass('is-open')) {
            $menuHolder.removeClass('is-active');
            $siteHeader.removeClass('mega-menu-open');
            $(this).removeClass('is-open');
          } else {
            if ($menuHolder.hasClass('is-active')) {
              $menuHolder.removeClass('is-active');
              $siteHeader.removeClass('mega-menu-open');
              $menuNavItem.removeClass('is-open');
            }
            if ($(e.target).is('span')) {
              eventTarget = $(e.target).parent('a');
            } else {
              eventTarget = e.target;
            }
            pointerPosition(eventTarget);
            $menuHolder.addClass('is-active');
            $siteHeader.addClass('mega-menu-open');

            // Hide search overlay
            $('#search-overlay').fadeOut(
              ANIM_LENGTH_MS,
              function afterFadeOut() {
                $(this).attr('aria-hidden', true);
              }
            );
            $siteHeader.removeClass('is-toggled-on');
            $('.search-overlay__dimmer').removeClass('is-toggled-on');
          }
        } else {
          $menuHolder.removeClass('is-active');
          $siteHeader.removeClass('mega-menu-open');
          $menuNavItem.removeClass('is-open');
        }
      }
    );
  } else {
    $menuNavItem.on('mouseover', function megaMenuNoTouchevents(e) {
      if ($(this).parent().hasClass('contain-mega')) {
        if ($menuHolder.hasClass('is-active')) {
          $menuHolder.removeClass('is-active');
          $siteHeader.removeClass('mega-menu-open');
          $menuNavItem.removeClass('is-open');
        }
        if ($(e.target).is('span')) {
          eventTarget = $(e.target).parent('a');
        } else {
          eventTarget = e.target;
        }
        pointerPosition(eventTarget);
        $menuHolder.addClass('is-active');
        $siteHeader.addClass('mega-menu-open');

        // Hide search overlay
        $('#search-overlay').fadeOut(
          ANIM_LENGTH_MS,
          function afterFadeOut() {
            $(this).attr('aria-hidden', true);
          }
        );
        $siteHeader.removeClass('is-toggled-on');
        $('.search-overlay__dimmer').removeClass('is-toggled-on');
      } else {
        $menuHolder.removeClass('is-active');
        $siteHeader.removeClass('mega-menu-open');
        $menuNavItem.removeClass('is-open');
      }
    });
  }

  $menuHolder.on('mouseleave', function megaMenuMouseLeave() {
    $(this).removeClass('is-active');
    $siteHeader.removeClass('mega-menu-open');
    $menuNavItem.removeClass('is-open');
  });

  function resize() {
    $menuHolder.css({
      height: $('.mega-menu__nav.is-visible').outerHeight(true) + 1
    });
  }

  $(window).resize(resize).trigger('resize');
})();

(function searchForm() {
  function handleClick() {
    if ($('#salesfire-search').hasClass('salesfire-open')) {
      $('#salesfire-search').hide();
      $('html').removeClass('sf-search-open');
      $('#salesfire-search').removeClass('salesfire-open');
    } else {
      $('#salesfire-search').show();
      $('#salesfire-search').addClass('salesfire-open');
    }
  }

  function mutationCaught(mutationsList) {
    if ($('#salesfire-search').html().length < 10) {
      $('#salesfire-search').removeClass('salesfire-open');
    }
  }

  setTimeout(function () {
    if ($('#salesfire-search').length > 0) {
      $(window).on('load', function () {
        var observer = new MutationObserver(mutationCaught);
        observer.observe(
          document.getElementById('salesfire-search'),
          {
            childList: true
          }
        );
      });

      $(document).on(
        'click',
        '#search-label.btn--invis',
        handleClick
      );
      $('.navbar-toggle').on('click', function () {
        if ($('#salesfire-search').hasClass('salesfire-open')) {
          handleClick();
        }
      });
    }
  }, 1000);
})();

(function modSizeGuide() {
  $('.tab-nav li').click(function () {
    var tab_id = $(this).attr('data-tab');

    $('.tab-nav li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $('#' + tab_id).addClass('current');
  });

  $('.js-unit-switcher').click(function () {
    $('.size-guide__wrapper').toggleClass('show-imperial');
  });
})();

/**
 * Lazy-loaded pagination with button via Infinite Scroll
 *
 * @see https://infinite-scroll.com/options.html
 * @requires vendor/infinite-scroll.pkgd.min.js
 * @exports window.rfd.lazyPagReinit()
 */

(function lazyPagFunction() {
  var selectors = {
    grid: '[button-pag-grid]',
    next: '[lazy-pag-next]',
    pag: '[lazy-pag-pag]',
    item: '[button-pag-item]'
  };

  var $container;

  function init() {
    if (!$(selectors.next).length) {
      console.log('[lazy-pag-button] no next (disabled)');
      $('.view-more-button').hide();
      return;
    }
    if (!$(selectors.grid).length) {
      console.log('[lazy-pag-button] no grid (disabled)');
      return;
    }

    $container = $(selectors.grid).infiniteScroll({
      append: selectors.item,
      path: selectors.next,
      hideNav: selectors.pag,
      checkLastPage: true,
      history: false,
      button: '.view-more-button', // using button, disable loading on scroll
      scrollThreshold: false
    });

    // @see https://infinite-scroll.com/events.html
    $container.on(
      'append.infiniteScroll',
      function lazyPagAppend(event, response, path, items) {
        var sections;

        console.log('[lazy-pag-button] appended ' + items.length);

        if (typeof yotpo !== 'undefined') {
          yotpo.initWidgets();
        }
      }
    );

    $container.on(
      'request.infiniteScroll',
      function lazyPagRequest(event, path) {
        console.log('[lazy-pag-button] loading page: ' + path);
      }
    );

    $container.on('last.infiniteScroll', function lazyPagLast() {
      console.log('[lazy-pag-button] last page loaded');
    });
  }

  init();
})();

/**
 * Module for color option on PDP.
 *
 */

(function colorOptionFunction() {
  function colorOption(event) {
    let el = event.currentTarget;
    const elHandle = el.getAttribute('data-handle');
    const colorOption =
      document.getElementsByClassName('color-option');
    for (let i = 0; i < colorOption.length; i++) {
      colorOption[i].classList.add('hide');
      if (colorOption[i].classList.contains(elHandle)) {
        colorOption[i].classList.remove('hide');
      }
    }
  }

  function revertColorOption() {
    const colorOption =
      document.getElementsByClassName('color-option');
    for (let i = 0; i < colorOption.length; i++) {
      colorOption[i].classList.add('hide');
      if (colorOption[i].classList.contains('current-color')) {
        colorOption[i].classList.remove('hide');
      }
    }
  }

  function _init() {
    $('.no-touchevents .color-option-handle').mouseover(colorOption);
    $('.no-touchevents .color-option-handle').mouseout(
      revertColorOption
    );
  }

  _init();
})();

/* eslint-disable no-empty */
/* eslint-disable no-redeclare */
/* eslint-disable func-names */
/* eslint-disable no-extra-boolean-cast */

const shopifyUrlLocale =
  Shopify.country === 'GB'
    ? false
    : `/${Shopify.locale}-${Shopify.country.toLowerCase()}`;

Shopify.Products = (function () {
  var config = {
    maxToShow: 8,
    minToShow: 4,
    howManyToStoreInMemory: 10,
    gallerySection: '[data-gallery-recently-section]',
    galleryContainer: '[data-gallery-recently]',
    gallerySlide: '.glide__slide',
    onComplete: null
  };

  var productHandleQueue = [];

  var cookie = {
    configuration: {
      expires: 90,
      path: ''
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      Cookies.set(
        this.name,
        recentlyViewed.join(','),
        this.configuration
      );
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = Cookies.get(this.name);
      if (cookieValue) {
        recentlyViewed = cookieValue.split(',');
      }
      return recentlyViewed;
    },
    destroy: function () {
      Cookies.remove(this.name);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function () {
    var $gallerySection = $(config.gallerySection);
    if ($gallerySection.find(config.gallerySlide).length) {
      $gallerySection.show();
    }
    if (window.rfd && window.rfd.initAjaxCarousels) {
      window.rfd.initAjaxCarousels();
    }

    $('.resize-wrap').each(function resizeMe() {
      $(this).find('.resize-me').matchHeight();
    });

    // Rerun coming soon countdown JS
    if (window.rfd && window.rfd.initComingSoonCountdowns) {
      window.rfd.initComingSoonCountdowns();
    }

    // Rerun lightning countdown JS
    if (window.rfd && window.rfd.initLightningCountdowns) {
      window.rfd.initLightningCountdowns();
    }

    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {}
    }
  };

  var getRecentProducts = function () {
    var searchRecentlyUrl;
    var productHandle = window.location.pathname.match(
      /\/products\/([a-z0-9\-]+)/
    )[1];
    productHandleQueue = productHandleQueue.filter(function (handle) {
      return productHandle !== handle;
    });
    if (productHandleQueue.length < config.minToShow) {
      return;
    }
    productHandleQueue.length = config.maxToShow;
    searchRecentlyUrl =
      '/search?view=recently&q=' + productHandleQueue.toString();
    console.log('productHandleQueue', productHandleQueue.toString());
    console.log(
      'https://' + window.location.host + searchRecentlyUrl
    );
    $.get(searchRecentlyUrl, function (data) {
      const localeData = shopifyUrlLocale
        ? data.replace(
            new RegExp('href="/products', 'g'),
            `href="${shopifyUrlLocale}/products`
          )
        : data;
      $(config.galleryContainer).empty().append(localeData);
    }).done(function () {
      finalize();
    });
  };

  return {
    showRecentlyViewed: function (params) {
      var params = params || {};
      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      if (
        productHandleQueue === null ||
        productHandleQueue === undefined
      ) {
        return false;
      }

      config.maxToShow = Math.min(
        productHandleQueue.length,
        config.maxToShow
      );

      if (config.maxToShow) {
        getRecentProducts();
      } else {
        $('[data-may-also-like]').css('margin-left', '0');
        $('.tabs-titles.recently [data-title]').hide();
      }
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {
      var params = params || {};
      var recentlyViewed = cookie.read();
      var productHandle;
      var position;

      // Update defaults.
      jQuery.extend(config, params);

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {
        // What is the product handle on this page.
        productHandle = window.location.pathname.match(
          /\/products\/([a-z0-9\-]+)/
        )[1];
        // In what position is that product in memory.
        position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(
            0,
            config.howManyToStoreInMemory
          );
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    }
  };
})();

/**
 * Collection filters
 *
 */

(function modFilters() {
  let anyFiltersPresent = false;

  $('body').on('click', '.js-filters-heading', function () {
    $(this).parent().toggleClass('open');
  });

  $('.filters__list').each(function () {
    var $this = $(this);

    $this.find('input').on('change', function () {
      $this.find('input').not(this).prop('checked', false);
    });

    if ($this.children().length == 0) {
      $this.closest('.menu-accordion__item').remove();
    } else {
      anyFiltersPresent = true;
    }
  });

  if (anyFiltersPresent === false) {
    $('.js-filters-column, .js-mobile-filters-link').remove();
    $('.js-products-column').removeClass('large-up--three-quarters');
    $('.js-sort-link')
      .removeClass('one-half medium-down--text-center')
      .addClass('three-quarters');
  }

  $('#filters input[type=checkbox]').each(function () {
    var $this = $(this);
    var checkboxID = this.id;
    var newCheckboxID = checkboxID + '-mobile';
    $this.attr('id', newCheckboxID);
    $(this).parent('label').attr('for', newCheckboxID);
  });

  $('body').on('submit', '.js-filters-form', function (e) {
    e.preventDefault();
    var t,
      a,
      n = $(this),
      o = window.location.origin,
      r = new RegExp('[?&]sort_by=([^&#]*)').exec(
        window.location.href
      ),
      s = window.location.pathname.split('/'),
      l = window.location.href,
      d = [],
      u = '';
    for (
      t = s.indexOf('collections') + 1,
        a = s[t],
        n.find('input[name^="tag"]').each(function () {
          var e = $(this);
          e.is(':checked') && d.push(e.val());
        }),
        i = 0;
      i < d.length;
      i++
    )
      u = i > 0 ? u + '+' + d[i] : d[i];
    (l =
      '' !== u
        ? o + '/collections/' + a + '/' + u
        : o + '/collections/' + a),
      r && (l += r = r[0]),
      (window.location.href = l);
  });
})();

/**
 * Collection sorting
 *
 */

(function modSorting() {
  /*
	$('.js-sort-list').on('change', function() {
		var url = $(this).val();
		if (url) {
			window.location = url;
		}
		return false;
	});
	*/

  $('.sortby-link').on('click', function (e) {
    e.preventDefault();
  });
})();

(function quickBuyInit() {
  function toggleMobileQuickbuy(elementID, event) {
    var el = document.getElementById(elementID);
    if (el.classList.contains('soft-hide-mob')) {
      el.classList.remove('mqb-transition-out');
      el.classList.remove('soft-hide-mob');
      el.classList.add('mqb-transition-in');
    } else {
      if (
        event.target.nodeName == 'svg' ||
        event.target.className.includes('quick-buy-container') ||
        event.target.className.includes('close-mqb')
      ) {
        el.classList.remove('mqb-transition-in');
        el.classList.add('mqb-transition-out');
        setTimeout(function () {
          el.classList.add('soft-hide-mob');
        }, 500);
        return;
      }
    }
  }
  function openMobileQuickbuy(elementID, event) {
    var el = document.getElementById(elementID);
    if (el.classList.contains('soft-hide-mob')) {
      el.classList.remove('mqb-transition-out');
      el.classList.remove('soft-hide-mob');
      el.classList.add('mqb-transition-in');
    }
  }
  function closeMobileQuickbuy(elementID, event) {
    var el = document.getElementById(elementID);
    el.classList.remove('mqb-transition-in');
    el.classList.add('mqb-transition-out');
    setTimeout(function () {
      el.classList.add('soft-hide-mob');
    }, 500);
  }

  window.rfd.toggleMobileQuickbuy = toggleMobileQuickbuy;
  window.rfd.openMobileQuickbuy = openMobileQuickbuy;
  window.rfd.closeMobileQuickbuy = closeMobileQuickbuy;
})();

/**
 * Toggle between variants on quick add buttons
 *
 */

(function modQuickAddVariants() {
  var selectors = {
    container: '[data-variants-holder]',
    quickAddRadio: '.quick-add-radio',
    quickAddBtn: 'data-quick-add-variant'
  };

  function toggleQuickAddBtn() {
    var $val = $(this).val();
    var $container = $(this).closest(selectors.container);
    var $quickAddBtns = $container.find(
      '[' + selectors.quickAddBtn + ']'
    );
    var $thisQuickAddBtn = $quickAddBtns.filter(
      '[' + selectors.quickAddBtn + '=' + $val + ']'
    );

    $quickAddBtns.hide();
    $thisQuickAddBtn.show();
  }

  function updateJointSelectOptions() {
    var $optionsGroup = $(this).closest('.options-wrapper');
    var selects = $optionsGroup.find('.upsell-select-variant');
    var values = [].map
      .call(selects, function (input) {
        return input.value;
      })
      .join(' / ');

    const textToFind = values;
    const $optionsGroupSelect = $optionsGroup
      .closest('[data-variants-holder]')
      .find('.js-variant-select');

    for (
      var i = 0;
      i < $optionsGroupSelect.children('option').length;
      i++
    ) {
      if (
        $.trim(
          $optionsGroupSelect.children('option').eq(i).text()
        ) === textToFind
      ) {
        $optionsGroupSelect.prop('selectedIndex', i);
        break;
      }
    }

    $optionsGroupSelect.trigger('change');
  }

  function init() {
    $('.js-variant-select').on('change', toggleQuickAddBtn);
    $('.upsell-select-variant').on(
      'change',
      updateJointSelectOptions
    );
  }

  init();

  window.rfd = window.rfd || {};
  window.rfd.initQuickAddVariants = init;
})();

(function modCollectionView() {
  'use strict';

  var viewCookie;

  var $container;

  function swiperInit() {
    document
      .querySelectorAll('.swiper-container')
      .forEach(container => {
        const swiper = new Swiper(container, {
          // Optional parameters
          direction: 'horizontal',
          loop: true,
          followFinger: true,

          // If we need pagination
          pagination: {
            el: '.swiper-pagination'
          },

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });
      });
  }

  function afterSwitch() {
    // Rerun resizeMe for the product flags
    if (window.rfd && window.rfd.resizeMe) {
      window.rfd.resizeMe();
    }
  }

  if (document.body.classList.contains('template-collection')) {
    document
      .querySelector('.js-collection-list-view')
      .addEventListener('click', () => {
        document.body.classList.add('list-view');
        Cookies.set('collection-display', 'list-view');
        afterSwitch();
        swiperInit();
      });

    document
      .querySelector('.js-collection-grid-view')
      .addEventListener('click', () => {
        document.body.classList.remove('list-view');
        Cookies.set('collection-display', 'grid-view');
        afterSwitch();
        swiperInit();
      });

    viewCookie = Cookies.get('collection-display');

    if (viewCookie === 'list-view') {
      document.body.classList.add('list-view');
      afterSwitch();
      swiperInit();
    } else if (viewCookie === 'grid-view') {
      document.body.classList.remove('list-view');
      afterSwitch();
    }
  }
})();

/**
 * Promo countdown.
 *
 * @requires vendor/_jquery-3.3.1.min.js
 * @requires vendor/moment.min.js
 * @requires vendor/moment-timezone-with-data.min.js
 *
 */

(function promoCountdown() {
  'use strict';

  var selectors = {
    countdownWrapper: '.countdown',
    countdownClock: '.countdown .countdown__clock',
    countdownStartDay: 'start-day',
    countdownStartTime: 'start-time',
    countdownEndDay: 'end-day',
    countdownEndTime: 'end-time',
    countdownTimezone: 'timezone'
  };

  // eslint-disable-next-line require-jsdoc
  function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width
      ? n
      : new Array(width - n.length + 1).join(z) + n;
  }

  function init() {
    var $countdownClock = $(selectors.countdownClock);

    if (!$countdownClock.length) {
      return;
    }

    $countdownClock.each(function countdownClockF() {
      var countdownStartDay = $(this).data(
        selectors.countdownStartDay
      );
      var countdownStartTime = $(this).data(
        selectors.countdownStartTime
      );
      var countdownEndDay = $(this).data(selectors.countdownEndDay);
      var countdownEndTime = $(this).data(selectors.countdownEndTime);
      var countdownTimezone = $(this).data(
        selectors.countdownTimezone
      );
      var days;
      var hours;
      var mins;
      var secs;

      var nextYear = window.moment(
        countdownEndDay + 'T' + countdownEndTime + countdownTimezone
      );
      var startdate = window.moment(
        countdownStartDay +
          'T' +
          countdownStartTime +
          countdownTimezone
      );
      var enddate = window.moment(
        countdownEndDay + 'T' + countdownEndTime + countdownTimezone
      );

      if (
        new Date() >= new Date(startdate) &&
        new Date() <= new Date(enddate)
      ) {
        $(this).closest(selectors.countdownWrapper).show();
        $(this).countdown(
          nextYear.toDate(),
          function buildCountdown(event) {
            days = event.strftime('%D');
            hours = event.strftime('%H');
            hours = pad(hours, 2);
            mins = event.strftime('%M');
            secs = event.strftime('%S');

            if (event.offset.totalDays < 1) {
              $(this).find('.days').hide();
            }
            $(this).find('.days strong').html(days);
            $(this).find('.hours strong').html(hours);
            $(this).find('.mins strong').html(mins);
            $(this).find('.secs strong').html(secs);

            if (
              days === '00' &&
              hours === '00' &&
              mins === '00' &&
              secs === '00'
            ) {
              $(this).closest(selectors.countdownWrapper).hide();
            }
          }
        );
      }
    });
  }

  init();
  window.rfd.initCountdowns = init;
})();

(function giftWrapping() {
  const selectors = {
    holder: '.js-gift-wrap-holder',
    atcContent: '.js-gift-wrap-atc-content',
    checkbox: '.js-gift-wrap-checkbox',
    previewBox: '.js-gift-wrap-preview-box',
    toggleButton: '.js-gift-wrap-preview-toggle-button',
    messageContainer: '.js-gift-wrap-message-container',
    message: '.js-gift-wrap-message',
    addButton: '.js-add-gift-wrapping'
  };

  let button,
    container,
    holder,
    giftWrapID,
    checkbox,
    content,
    previewBtns,
    previewBox,
    giftWrapInCart;

  function setVariables() {
    button = document.querySelector(selectors.addButton);

    if (!button) return;

    giftWrapID = button.dataset.add;
    container = document.querySelector(selectors.atcContent);
    holder = document.querySelector(selectors.holder);
    checkbox = document.querySelector(selectors.checkbox);
    content = document.querySelector(selectors.messageContainer);
    previewBtns = Array.from(
      document.querySelectorAll(selectors.toggleButton)
    );
    previewBox = document.querySelector(selectors.previewBox);

    giftWrapListeners();
  }

  function giftWrapListeners() {
    checkboxListener();
    previewBoxListener();
  }

  function previewBoxListener() {
    if (!previewBox) return;
    previewBtns.forEach(button => {
      button.addEventListener('click', () => {
        previewBox.classList.toggle('is-visible');
      });
    });
  }

  function showMessage(value) {
    let op = value ? 'add' : 'remove';

    content.classList[op]('is-visible');
    content.querySelector(selectors.message).focus();
  }

  function checkboxListener() {
    if (!checkbox) return;
    checkbox.addEventListener('change', () => {
      showMessage(checkbox.checked);
    });
  }

  function disableGiftWrapSection() {
    if (!holder) return;
    holder.removeChild(container);
  }

  function enableGiftWrapSection() {
    if (!holder) return;
    holder.appendChild(container);
  }

  function cartRequestCompleteListener() {
    $(document).on('cart.requestComplete', (event, cart) => {
      giftWrapInCart = cart.items.find(item => item.id == giftWrapID);
      giftWrapInCart
        ? disableGiftWrapSection()
        : enableGiftWrapSection();
    });
  }

  function cartRenderListener() {
    document.addEventListener('minicart:render.complete', () => {
      setVariables();
      giftWrapInCart
        ? disableGiftWrapSection()
        : enableGiftWrapSection();
    });
  }

  function checkIfGiftWrapInCart() {
    window.CartJS.getCart().then(cart => {
      const giftWrap = cart.items.find(item => item.id == giftWrapID);
      return giftWrap ? true : false;
    });
  }

  function _init() {
    let gitWrapAdded = checkIfGiftWrapInCart();

    setVariables();
    cartRequestCompleteListener();
    cartRenderListener();

    if (gitWrapAdded) {
      disableGiftWrapSection();
    }
  }

  _init();
})();

/**
 * Lightning deals countdown.
 *
 * @requires vendor/_jquery-3.3.1.min.js
 * @requires vendor/moment.min.js
 * @requires vendor/moment-timezone-with-data.min.js
 *
 */

(function lightningCountdown() {
  'use strict';

  var selectors = {
    countdownWrapper: '.lightning-deal-timer',
    countdownClock: '.lightning-deal-timer .countdown__figure',
    countdownImage: '.lightning-deal-image',
    productFlag: '.flag',
    countdownStartDay: 'start-day',
    countdownStartTime: 'start-time',
    countdownEndDay: 'end-day',
    countdownEndTime: 'end-time',
    countdownTimezone: 'timezone'
  };

  // eslint-disable-next-line require-jsdoc
  function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width
      ? n
      : new Array(width - n.length + 1).join(z) + n;
  }

  function init() {
    var $countdownClock = $(selectors.countdownClock);

    if (!$countdownClock.length) {
      return;
    }

    $countdownClock.each(function countdownClockF() {
      var countdownStartDay = $(this).data(
        selectors.countdownStartDay
      );
      var countdownStartTime = $(this).data(
        selectors.countdownStartTime
      );
      var countdownEndDay = $(this).data(selectors.countdownEndDay);
      var countdownEndTime = $(this).data(selectors.countdownEndTime);
      var countdownTimezone = $(this).data(
        selectors.countdownTimezone
      );
      var days;
      var hours;
      var mins;
      var secs;

      var nextYear = window.moment(
        countdownEndDay + 'T' + countdownEndTime + countdownTimezone
      );
      var startdate = window.moment(
        countdownStartDay +
          'T' +
          countdownStartTime +
          countdownTimezone
      );
      var enddate = window.moment(
        countdownEndDay + 'T' + countdownEndTime + countdownTimezone
      );

      if (
        new Date() >= new Date(startdate) &&
        new Date() <= new Date(enddate)
      ) {
        $(this)
          .closest(selectors.countdownWrapper)
          .css('display', 'flex');

        $(this)
          .closest('.product-card')
          .find(selectors.productFlag)
          .hide();

        $(this)
          .closest('.product-card')
          .find(selectors.countdownImage)
          .css('border', '2px solid black');

        // Rerun resizeMe for the product flags
        if (window.rfd && window.rfd.resizeMe) {
          window.rfd.resizeMe();
        }
        $(this).countdown(
          nextYear.toDate(),
          function buildCountdown(event) {
            days = event.strftime('%D');
            hours = event.strftime('%H');
            hours = pad(hours, 2);
            mins = event.strftime('%M');
            secs = event.strftime('%S');

            if (event.offset.totalDays < 1) {
              $(this).find('.days').hide();
            }
            $(this).find('.days span').html(days);
            $(this).find('.hours span').html(hours);
            $(this).find('.mins span').html(mins);
            $(this).find('.secs span').html(secs);

            if (
              days === '00' &&
              hours === '00' &&
              mins === '00' &&
              secs === '00'
            ) {
              $(this).closest(selectors.countdownWrapper).hide();

              $(this)
                .closest('.product-card')
                .find(selectors.productFlag)
                .show();

              $(this)
                .closest('.product-card')
                .find(selectors.countdownImage)
                .css('border', 'none');

              // Rerun resizeMe for the product flags
              if (window.rfd && window.rfd.resizeMe) {
                window.rfd.resizeMe();
              }
            }
          }
        );
      }
    });
  }

  init();
  window.rfd.initLightningCountdowns = init;
})();

/**
 * Coming soon countdown.
 *
 * @requires vendor/_jquery-3.3.1.min.js
 * @requires vendor/moment.min.js
 * @requires vendor/moment-timezone-with-data.min.js
 *
 */

(function comingSoonCountdown() {
  'use strict';

  var selectors = {
    countdownWrapper: '.coming-soon-timer',
    countdownClock: '.coming-soon-timer .countdown__figure',
    countdownImage: '.coming-soon-image',
    productFlag: '.flag',
    countdownStartDay: 'start-day',
    countdownStartTime: 'start-time',
    countdownEndDay: 'end-day',
    countdownEndTime: 'end-time',
    countdownTimezone: 'timezone'
  };

  // eslint-disable-next-line require-jsdoc
  function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width
      ? n
      : new Array(width - n.length + 1).join(z) + n;
  }

  function init() {
    var $countdownClock = $(selectors.countdownClock);

    if (!$countdownClock.length) {
      return;
    }

    $countdownClock.each(function countdownClockF() {
      var countdownStartDay = $(this).data(
        selectors.countdownStartDay
      );
      var countdownStartTime = $(this).data(
        selectors.countdownStartTime
      );
      var countdownEndDay = $(this).data(selectors.countdownEndDay);
      var countdownEndTime = $(this).data(selectors.countdownEndTime);
      var countdownTimezone = $(this).data(
        selectors.countdownTimezone
      );
      var days;
      var hours;
      var mins;
      var secs;

      var nextYear = window.moment(
        countdownEndDay + 'T' + countdownEndTime + countdownTimezone
      );
      var startdate = window.moment(
        countdownStartDay +
          'T' +
          countdownStartTime +
          countdownTimezone
      );
      var enddate = window.moment(
        countdownEndDay + 'T' + countdownEndTime + countdownTimezone
      );

      if (
        new Date() >= new Date(startdate) &&
        new Date() <= new Date(enddate)
      ) {
        $(this).closest(selectors.countdownWrapper).show();

        $(this)
          .closest('.product-card')
          .find(selectors.productFlag)
          .hide();

        $(this)
          .closest('.product-card')
          .find(selectors.countdownImage)
          .css('border', '2px solid black');

        // Rerun resizeMe for the product flags
        if (window.rfd && window.rfd.resizeMe) {
          window.rfd.resizeMe();
        }
        $(this).countdown(
          nextYear.toDate(),
          function buildCountdown(event) {
            days = event.strftime('%D');
            hours = event.strftime('%H');
            hours = pad(hours, 2);
            mins = event.strftime('%M');
            secs = event.strftime('%S');

            if (event.offset.totalDays < 1) {
              $(this).find('.days').hide();
            }
            $(this).find('.days span').html(days);
            $(this).find('.hours span').html(hours);
            $(this).find('.mins span').html(mins);
            $(this).find('.secs span').html(secs);

            if (
              days === '00' &&
              hours === '00' &&
              mins === '00' &&
              secs === '00'
            ) {
              $(this).closest(selectors.countdownWrapper).hide();

              $(this)
                .closest('.product-card')
                .find(selectors.productFlag)
                .show();

              $(this)
                .closest('.product-card')
                .find(selectors.countdownImage)
                .css('border', 'none');

              // Rerun resizeMe for the product flags
              if (window.rfd && window.rfd.resizeMe) {
                window.rfd.resizeMe();
              }
            }
          }
        );
      }
    });
  }

  // Hide countdown text if not
  if (!$('.template-product').length) {
    if ($(window).width() < 768) {
      $(
        '.coming-soon-timer .timer__text:not(.timer__text--constant)'
      ).hide();
    }
  }

  init();
  window.rfd.initComingSoonCountdowns = init;
})();

const VideoType = {
  YouTube,
  HTML5
};

function video() {
  const elements = Array.prototype.slice.call(
    document.querySelectorAll('.js-video')
  );

  if (elements.length === 0) return;

  const ALLOWED_TYPES = ['YouTube', 'HTML5'];

  const videos = elements.reduce(
    (acc, currentElement) => {
      const videoType =
        currentElement.getAttribute('data-video-type');

      if (!ALLOWED_TYPES.includes(videoType)) {
        console.error(`Your video type "${videoType}" is missing or is not supported.\n Make sure it is present on video element and matches one of following: ${ALLOWED_TYPES.join(
          ', '
        )}
									`);
        return acc;
      }

      acc[videoType].push(currentElement);
      return acc;
    },
    {
      YouTube: [],
      HTML5: []
    }
  );

  loadVideos(videos);

  async function loadVideos(videos) {
    for (const [type, value] of Object.entries(videos)) {
      if (value.length === 0) continue;
      if (type === 'YouTube') {
        _loadYT(type, value);
      } else {
        createVideos(type, value);
      }
    }
  }

  async function createVideos(type, value) {
    if (type === 'YouTube') {
      value.forEach(e => new YouTube(e));
    }
    if (type === 'HTML5') {
      value.forEach(e => new HTML5(e));
    }
  }

  function _loadYT(type, value) {
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/player_api';
    script.async = true;
    script.onload = () => createVideos(type, value);
    document.body.appendChild(script);
  }
}

function HTML5(e) {
  var player;

  function createPlayer() {
    if (player) return;

    const { mp4Source, webmSource } = container.dataset;

    container.innerHTML = `
					<video muted autoplay playsinline ${canLoop ? 'loop' : ''}>
							<source src="${webmSource}" type="video/webm">
							<source src="${mp4Source}" type="video/mp4">
					</video>
			`;
    player = container.firstElementChild;
    player.element = container.firstElementChild;

    player.addEventListener('canplay', () => _onReady());
    player.addEventListener('ended', () => onEnded());
    player.addEventListener('click', () => pause());
  }

  function _onReady() {
    player.reset = player.load;
    if (!canAutoplay) {
      player.volume = 0.5;
    }

    if (size === 'cover') {
      const { videoWidth, videoHeight } = player;
      watchResize(videoWidth, videoHeight);
    }

    isReady = true;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(flushQueue.bind(this));
    } else {
      flushQueue();
    }
  }
  var element = e;
  var canAutoplay = element.hasAttribute('data-autoplay');
  var canLoop = element.hasAttribute('data-loop-video');
  var canResetVideo = element.hasAttribute('data-reset-video');
  var container = element.querySelector('.js-video-container');
  var hooks = { beforePlay: [], afterEnd: [] };
  var id = element.getAttribute('data-video-id');
  var isPlaying = false;
  var isReady = false;
  var playTrigger = element.querySelector('.js-video-trigger');
  var queue = new Set();
  var size = element.getAttribute('data-video-size');
  var posterEl =
    container.parentElement.querySelector('.js-video-image');

  bindTrigger();
  observeElement();

  element.VideoInstance = this;
  element.dispatchEvent(new CustomEvent('videoloaded'));

  function bindTrigger() {
    if (!playTrigger) return;

    playTrigger.setAttribute('data-state', 'idle');
    playTrigger.addEventListener('click', () => {
      play();
    });
    playTrigger.addEventListener('animationend', () => {
      if (playTrigger.getAttribute('data-state') === 'paused') {
        playTrigger.setAttribute('data-state', 'idle');
      }
    });
  }

  function observeElement() {
    observe(
      container,
      inView => {
        if (inView && canAutoplay) {
          play();
        } else if (isReady) {
          pause();
        }
      },
      {
        threshold: 0.25
      }
    );
  }

  function play() {
    if (isPlaying) return;
    if (!isReady) {
      createPlayer();
      queueTask('play');
      return;
    }

    if (hooks.beforePlay) {
      hooks.beforePlay.forEach(hook => hook());
    }

    _playPromise = Promise.resolve(player.play());
    isPlaying = true;
    hideOverlayElements();
  }

  async function pause() {
    if (!isPlaying) return;
    if (!isReady || typeof _playPromise === 'undefined') {
      queueTask('pause');
      return;
    }

    await _playPromise;
    canResetVideo ? player.reset() : player.pause();

    isPlaying = false;
    if (!canAutoplay) {
      showOverlayElements();
    }
  }

  function onEnded() {
    if (canLoop) return;

    if (hooks.afterEnd) {
      hooks.afterEnd.forEach(hook => hook());
    }

    isPlaying = false;
    showOverlayElements();
  }

  function hideOverlayElements() {
    if (posterEl) {
      posterEl.setAttribute('data-state', 'hidden');
    }

    if (playTrigger) {
      playTrigger.setAttribute('data-state', 'playing');
    }
  }

  function showOverlayElements() {
    posterEl.setAttribute('data-state', 'visible');
    if (playTrigger) {
      playTrigger.setAttribute('data-state', 'paused');
    }
  }

  function watchResize(videoWidth, videoHeight) {
    const updateSize = (videoWidth, videoHeight) => {
      const widthScale = container.clientWidth / videoWidth,
        heightScale = container.clientHeight / videoHeight;

      let multiplier = 1;

      if (widthScale >= heightScale) {
        multiplier = heightScale;

        if (container.clientWidth > videoWidth * heightScale) {
          multiplier = widthScale;
        }
      } else {
        multiplier = widthScale;

        if (container.clientHeight > videoHeight * widthScale) {
          multiplier = heightScale;
        }
      }

      player.element.style.width = `${videoWidth * multiplier}px`;
      player.element.style.height = `${videoHeight * multiplier}px`;
    };

    window.addEventListener('resize', () =>
      updateSize(videoWidth, videoHeight)
    );
    updateSize(videoWidth, videoHeight);

    player.element.setAttribute('tabindex', '-1');
  }

  function flushQueue() {
    queue.forEach(command => {
      this[command]();
    });
    queue.clear();
  }

  function queueTask(command) {
    queue.add(command);
  }
}

function YouTube(e) {
  var player;
  function createPlayer() {
    window.YT.ready(function () {
      if (player) return;

      container.innerHTML = '<div></div>';

      player = new YT.Player(container.firstElementChild, {
        videoId: id,
        playerVars: {
          autoplay: 1,
          controls: 0,
          loop: canLoop ? 1 : 0,
          modestbranding: 1,
          playlist: id,
          playsinline: 1,
          rel: 0,
          showinfo: 0
        },
        events: {
          onReady: () => onReady(),
          onStateChange: ({ data }) => {
            /**
             * -1 - Unstarted
             *  0 - Ended
             *  1 - Playing
             *  2 = Paused
             *  3 - Buffering
             *  5 - Cued
             */
            if (data === 0) {
              onEnded();
            } else if (data === 2) {
              pause();
            }
          }
        }
      });
      player.element = player.getIframe();
    });
  }

  function onReady() {
    player.play = player.playVideo;
    player.pause = player.pauseVideo;
    player.reset = player.stopVideo;

    canAutoplay ? player.mute() : player.setVolume(50);

    if (size === 'cover') {
      const { width: videoWidth, height: videoHeight } =
        player.element;
      watchResize(videoWidth, videoHeight);
    }

    isReady = true;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(flushQueue.bind(this));
    } else {
      flushQueue();
    }
  }
  var element = e;
  var canAutoplay = element.hasAttribute('data-autoplay');
  var canLoop = element.hasAttribute('data-loop-video');
  var canResetVideo = element.hasAttribute('data-reset-video');
  var container = element.querySelector('.js-video-container');
  var hooks = { beforePlay: [], afterEnd: [] };
  var id = element.getAttribute('data-video-id');
  var isPlaying = false;
  var isReady = false;
  var playTrigger = element.querySelector('.js-video-trigger');
  var queue = new Set();
  var size = element.getAttribute('data-video-size');
  var posterEl =
    container.parentElement.querySelector('.js-video-image');

  bindTrigger();
  observeElement();

  element.VideoInstance = this;
  element.dispatchEvent(new CustomEvent('videoloaded'));

  function bindTrigger() {
    if (!playTrigger) return;

    playTrigger.setAttribute('data-state', 'idle');
    playTrigger.addEventListener('click', () => {
      play();
    });
    playTrigger.addEventListener('animationend', () => {
      if (playTrigger.getAttribute('data-state') === 'paused') {
        playTrigger.setAttribute('data-state', 'idle');
      }
    });
  }

  function observeElement() {
    observe(
      container,
      inView => {
        if (inView && canAutoplay) {
          play();
        } else if (isReady) {
          pause();
        }
      },
      {
        threshold: 0.25
      }
    );
  }

  function play() {
    if (isPlaying) return;
    if (!isReady) {
      createPlayer();
      queueTask('play');
      return;
    }

    if (hooks.beforePlay) {
      hooks.beforePlay.forEach(hook => hook());
    }

    _playPromise = Promise.resolve(player.play());
    isPlaying = true;
    hideOverlayElements();
  }

  async function pause() {
    if (!isPlaying) return;
    if (!isReady || typeof _playPromise === 'undefined') {
      queueTask('pause');
      return;
    }

    await _playPromise;
    canResetVideo ? player.reset() : player.pause();

    isPlaying = false;
    if (!canAutoplay) {
      showOverlayElements();
    }
  }

  function onEnded() {
    if (canLoop) return;

    if (hooks.afterEnd) {
      hooks.afterEnd.forEach(hook => hook());
    }

    isPlaying = false;
    showOverlayElements();
  }

  function hideOverlayElements() {
    if (posterEl) {
      posterEl.setAttribute('data-state', 'hidden');
    }

    if (playTrigger) {
      playTrigger.setAttribute('data-state', 'playing');
    }
  }

  function showOverlayElements() {
    posterEl.setAttribute('data-state', 'visible');
    if (playTrigger) {
      playTrigger.setAttribute('data-state', 'paused');
    }
  }

  function watchResize(videoWidth, videoHeight) {
    const updateSize = (videoWidth, videoHeight) => {
      const widthScale = container.clientWidth / videoWidth,
        heightScale = container.clientHeight / videoHeight;

      let multiplier = 1;

      if (widthScale >= heightScale) {
        multiplier = heightScale;

        if (container.clientWidth > videoWidth * heightScale) {
          multiplier = widthScale;
        }
      } else {
        multiplier = widthScale;

        if (container.clientHeight > videoHeight * widthScale) {
          multiplier = heightScale;
        }
      }

      player.element.style.width = `${videoWidth * multiplier}px`;
      player.element.style.height = `${videoHeight * multiplier}px`;
    };

    window.addEventListener('resize', () =>
      updateSize(videoWidth, videoHeight)
    );
    updateSize(videoWidth, videoHeight);

    player.element.setAttribute('tabindex', '-1');
  }

  function flushQueue() {
    queue.forEach(command => {
      this[command]();
    });
    queue.clear();
  }

  function queueTask(command) {
    queue.add(command);
  }
}

document.addEventListener('DOMContentLoaded', function (event) {
  // Your code to run since DOM is loaded and ready
  function createObserver(
    element,
    threshold,
    callbackIn,
    callbackOut
  ) {
    if (!threshold) {
      // set default value
      threshold = [0.5];
    }

    var config = {
      threshold: threshold
    };

    var observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          function callbackIn() {
            var element = document.createElement('script');
            element.setAttribute('rel', 'stylesheet');
            element.setAttribute('type', 'text/javascript');
            element.setAttribute(
              'src',
              'https://foursixty.com/media/scripts/fs.embed.v2.5.js'
            );
            element.setAttribute(
              'data-feed-id',
              'bee-inspired-clothing'
            );
            element.setAttribute('data-use-stored-image-url', 'true');
            element.setAttribute('data-defer-image-loading', 'false');
            element.setAttribute('data-theme', 'sizes_v2_5');
            element.setAttribute(
              'data-money-format',
              '£<%= amount %>'
            );
            element.setAttribute('data-page-size', '28');
            document.getElementById('foursixty').appendChild(element);
            callbackOut();
          }
          callbackIn();
          function callbackOut() {
            observer.unobserve(document.getElementById('foursixty'));
          }
        }
      });
    }, config);
    observer.observe(element);
  }
  createObserver(document.querySelector('.js-foursixty-section'));
});

class PreorderPopup extends HTMLElement {
  constructor() {
    super();
    this.preorderPopup = this.querySelector('.js-preorder-popup')
  }

  connectedCallback() {
    this.addEventHandlers();
  }

  addEventHandlers() {
    if (this.dataset.openInDesignMode === 'true') {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) {
          window.rfd.modal.open(this.preorderPopup, false);
          this.preorderPopup.classList.toggle('is-open');
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(this)) {
          window.rfd.modal.close(this.preorderPopup);
          this.preorderPopup.classList.toggle('is-open');
        }
      });
    }
  }
}

customElements.define('preorder-popup', PreorderPopup);

/**
 * Set cookie.
 */
const setCookies = (name, value, days) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

/**
 * Get cookie data.
 */
const getCookies = (name) => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Erase cookie value
 */
const eraseCookies = (name) => {
  document.cookie = name + '=; Max-Age=-99999999';
};

/*================ Hacks ================*/
/**
 * A place for temporary hacks (hopefully empty)
 *
 */

(function shame() {
  // hacks go here
})();

$(document).ready(function () {
  video();
  window.onscroll = function () {
    mobileHeaderScroll();
  };

  function mobileHeaderScroll() {
    const header = document.querySelector('.sticky-site-header');
    const content = document.querySelector('.offcanvas-canvas');
    let headerHeight = header.clientHeight;

    let sticky = header.offsetTop;
    if (window.pageYOffset > sticky) {
      header.classList.add('sticky');
      content.style.paddingTop = headerHeight + 'px';
    } else {
      header.classList.remove('sticky');
      content.style.paddingTop = '0px';
    }
  }

  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper'
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        'supports-no-cookies',
        'supports-cookies'
      );
  }
});

/*
 * Klarna and clearpay customization
 */

window.addEventListener('load', event => {
  document.querySelector(
    '#klarna-promo > div'
  ).shadowRoot.innerHTML += `
		<style>
			.logo {
					position: absolute;
					left: 0;
					top: -.2rem;
					margin-right: 2rem;
					background-color: #FFB3C7;
					border-radius: 0.4rem;
					padding: 0.2rem 0.6rem;
				}

			button.link {
				display: none;
			}

			.container {
				padding-left: 6.9rem!important;
				position: relative!important;
				text-align: left;
			}
		</style>`;

  let host = document.querySelector('afterpay-placement');
  let style = document.createElement('style');
  style.innerHTML =
    '.afterpay-logo-link { order: -1; }' +
    '.afterpay-logo { min-height: 26px!important;  background: #B2FCE4;border-radius: 13px; padding: 2px 4px 0 8px; }' +
    '.afterpay-link {margin-right: 10px!important;}' +
    '.afterpay-logo.brand-clearpay svg {max-width: 80px;}' +
    '.afterpay-paragraph {display: flex; }';

  host.shadowRoot.appendChild(style);
});
